import React, {
  useRef,
  useImperativeHandle,
  useContext,
  useState,
  useEffect,
} from 'react';
import {
  Box,
  TextField,
  Button,
  Tabs,
  Tab,
  FormControlLabel,
  Radio,
  RadioGroup,
  InputAdornment,
  Input,
  IconButton,
  FormControl,
  InputLabel,
  Checkbox,
  useTheme,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import { useForm, Controller } from 'react-hook-form';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import { useSelector, useDispatch } from 'dva';
import { Context } from '../../index';
import TitleML from '../TitleML/TitleML';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import DialogML from '@/components/DialogML';
import DataTableNativeML from '@/components/DataTableNativeML';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import {
  download,
  uploadExcel,
  downLoadPrivateFile,
} from '@/utils/downloadUtil';
import Loading from '@/components/loading_ml/Loading';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

//计算总页数
const initPageSize = (num) => {
  return Math.ceil(num / 10);
};
//计算当前分页的列表
const initDataTables = (list, page) => {
  const startPage = page > 1 ? (page - 1) * 10 : 0;
  const endPage = 10;
  const data = [...list].splice(startPage, endPage);
  return data;
};
export default React.forwardRef(
  // eslint-disable-next-line no-unused-vars
  (
    {
      onSubmitSuccess,
      handleClickSearchProducts,
      queryType = null,
      handleClickSearchProductsStyles,
      handleClickSearchProductsSeries,
      handleClickSearchProductsGoods,
      handleClickSearchProductsSeason,
      handleClickSearchProductsSubclass,
      handleClickSearchProductsDesign,
      handleClickSearchProductsCategory,
      formatMessage,
    },
    // eslint-disable-next-line no-unused-vars
    fref,
  ) => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const { control, handleSubmit, errors, setValue, getValues } = useForm();
    const [productsTypeChooseState, setProductsTypeChooseState] = useState();
    const [dialogStatus, setDialogStatus] = useState(false); //选中产品model的状态
    const [dialogStatusNo, setDialogStatusNo] = useState(false); //选中不可用产品model的状态
    const [value, setTabValue] = React.useState(0); //选择商品value
    const [valueChoose, setTabValueChoose] = React.useState(0); //选中商品value
    const [valueChooseNo, setTabValueChooseNo] = React.useState(0); //不可用选中商品value
    const [noUseProduct, setNoUseProduct] = useState();
    const [useProduct, setUseProduct] = useState();

    const [seriesPage, setSeriesPage] = useState(1);
    const [stylesPage, setStylesPage] = useState(1);
    const [stylesPageNo, setStylesPageNo] = useState(1);
    const [goodsPageNo, setGoodsPageNo] = useState(1);
    const [goodsPage, setGoodsPage] = useState(1);
    const [productPage, setProductPage] = useState(1);
    const [seriesPageNo, setSeriesPageNo] = useState(1);
    const [productPageNo, setProductPageNo] = useState(1);
    const [seasonPage, setSeasonPage] = useState(1);
    const [subclassPage, setSubclassPage] = useState(1);
    const [designPage, setDesignPage] = useState(1);
    const [categoryPage, setCategoryPage] = useState(1);
    const [seasonPageNo, setSeasonPageNo] = useState(1);
    const [subclassPageNo, setSubclassPageNo] = useState(1);
    const [designPageNo, setDesignPageNo] = useState(1);
    const [categoryPageNo, setCategoryPageNo] = useState(1);
    // 批量导入dialog状态
    const [batchImportOpen, setBatchImportOpen] = useState(false);
    //批量上传的input
    const inputUploadExcelRef = useRef();
    //No.
    //可用
    const [productsChooseDataId, setProductsChooseDataId] = useState([]); //选中的门店Id
    const [productsChooseItemData, setProductsChooseItemData] = useState([]); //存储所有选中数据列
    const [productsChooseItemShowData, setProductsChooseItemShowData] =
      useState([]); //选中的门店点确定后的值列
    const [productsChooseItemShowIdData, setProductsChooseItemShowIdData] =
      useState([]); //选中的门店点确定后的值Id
    //不可用
    const [productsChooseDataIdNo, setProductsChooseDataIdNo] = useState([]); //选中的门店Id
    const [productsChooseItemDataNo, setProductsChooseItemDataNo] = useState(
      [],
    ); //存储所有选中数据列
    const [productsChooseItemShowDataNo, setProductsChooseItemShowDataNo] =
      useState([]); //选中的门店点确定后的值列
    const [productsChooseItemShowIdDataNo, setProductsChooseItemShowIdDataNo] =
      useState([]); //选中的门店点确定后的值Id
    const productsNameRef = useRef(null);
    const productsNameRefNo = useRef(null);
    //series
    //可用
    const [productsChooseDataIdSeries, setProductsChooseDataIdSeries] =
      useState([]); //选中的门店Id
    // 款式产品选中id
    const [productsChooseDataIdGoods, setProductsChooseDataIdGoods] = useState(
      [],
    );
    const [productsChooseDataIdStyles, setProductsChooseDataIdStyles] =
      useState([]); //选中的门店Id
    const [productsChooseItemDataSeries, setProductsChooseItemDataSeries] =
      useState([]); //存储所有选中数据列
    const [productsChooseItemDataGoods, setProductsChooseItemDataGoods] =
      useState([]);
    const [
      productsChooseItemShowDataSeries,
      setProductsChooseItemShowDataSeries,
    ] = useState([]); //选中的门店点确定后的值列
    const [
      productsChooseItemShowDataGoods,
      setProductsChooseItemShowDataGoods,
    ] = useState([]);
    // 款式
    const [
      productsChooseItemShowDataStyles,
      setProductsChooseItemShowDataStyles,
    ] = useState([]);

    const [
      productsChooseItemShowIdDataSeries,
      setProductsChooseItemShowIdDataSeries,
    ] = useState([]); //选中的门店点确定后的值Id
    const [
      productsChooseItemShowIdDataGoods,
      setProductsChooseItemShowIdDataGoods,
    ] = useState([]);
    // 款式产品的选中值
    const [
      productsChooseItemShowIdDataStyles,
      setProductsChooseItemShowIdDataStyles,
    ] = useState([]); //选中的门店点确定后的值Id
    //不可用
    const [productsChooseDataIdSeriesNo, setProductsChooseDataIdSeriesNo] =
      useState([]); //选中的门店Id
    // 不可用款号
    const [productsChooseDataIdStylesNo, setProductsChooseDataIdStylesNo] =
      useState([]); //选中的门店Id
    const [productsChooseItemDataSeriesNo, setProductsChooseItemDataSeriesNo] =
      useState([]); //存储所有选中数据列
    const [productsChooseItemDataGoodsNo, setProductsChooseItemDataGoodsNo] =
      useState([]);
    const [productsChooseItemDataStylesNo, setProductsChooseItemDataStylesNo] =
      useState([]);
    const [
      productsChooseItemShowDataSeriesNo,
      setProductsChooseItemShowDataSeriesNo,
    ] = useState([]); //选中的门店点确定后的值列
    const [
      productsChooseItemShowDataStylesNo,
      setProductsChooseItemShowDataStylesNo,
    ] = useState([]);
    const [
      productsChooseItemShowIdDataSeriesNo,
      setProductsChooseItemShowIdDataSeriesNo,
    ] = useState([]); //选中的门店点确定后的值Id
    const [
      productsChooseItemShowDataGoodsNo,
      setProductsChooseItemShowDataGoodsNo,
    ] = useState([]);
    const [
      productsChooseItemShowIdDataGoodsNo,
      setProductsChooseItemShowIdDataGoodsNo,
    ] = useState([]);

    // const [
    //   productsChooseItemShowIdDataGoodsNo,
    //   setProductsChooseItemShowDataGoodsNo,
    // ] = useState([]);
    const [
      productsChooseItemShowIdDataStylesNo,
      setProductsChooseItemShowIdDataStylesNo,
    ] = useState([]);
    const productsNameSeriesRef = useRef(null);
    const productsNameSeriesRefNo = useRef(null);
    // 款号商品
    const productsNameStylesRef = useRef(null);
    const productsNameGoodsRef = useRef(null);
    const productsNameGoodsRefNo = useRef(null);
    const productsNameStylesRefNo = useRef(null);

    //Season
    //可用
    const [productsChooseDataIdSeason, setProductsChooseDataIdSeason] =
      useState([]); //选中的门店Id
    const [productsChooseItemDataSeason, setProductsChooseItemDataSeason] =
      useState([]); //存储所有选中数据列
    const [
      productsChooseItemShowDataSeason,
      setProductsChooseItemShowDataSeason,
    ] = useState([]); //选中的门店点确定后的值列
    const [
      productsChooseItemShowIdDataSeason,
      setProductsChooseItemShowIdDataSeason,
    ] = useState([]); //选中的门店点确定后的值Id
    //不可用
    const [productsChooseDataIdSeasonNo, setProductsChooseDataIdSeasonNo] =
      useState([]); //选中的门店Id
    const [productsChooseItemDataSeasonNo, setProductsChooseItemDataSeasonNo] =
      useState([]); //存储所有选中数据列
    const [
      productsChooseItemShowDataSeasonNo,
      setProductsChooseItemShowDataSeasonNo,
    ] = useState([]); //选中的门店点确定后的值列
    const [
      productsChooseItemShowIdDataSeasonNo,
      setProductsChooseItemShowIdDataSeasonNo,
    ] = useState([]); //选中的门店点确定后的值Id
    const productsNameSeasonRef = useRef(null);
    const productsNameSeasonRefNo = useRef(null);

    //Subclass
    //可用
    const [productsChooseDataIdSubclass, setProductsChooseDataIdSubclass] =
      useState([]); //选中的门店Id
    const [productsChooseItemDataSubclass, setProductsChooseItemDataSubclass] =
      useState([]); //存储所有选中数据列
    const [
      productsChooseItemShowDataSubclass,
      setProductsChooseItemShowDataSubclass,
    ] = useState([]); //选中的门店点确定后的值列
    const [
      productsChooseItemShowIdDataSubclass,
      setProductsChooseItemShowIdDataSubclass,
    ] = useState([]); //选中的门店点确定后的值Id
    //不可用
    const [productsChooseDataIdSubclassNo, setProductsChooseDataIdSubclassNo] =
      useState([]); //选中的门店Id
    const [
      productsChooseItemDataSubclassNo,
      setProductsChooseItemDataSubclassNo,
    ] = useState([]); //存储所有选中数据列
    const [
      productsChooseItemShowDataSubclassNo,
      setProductsChooseItemShowDataSubclassNo,
    ] = useState([]); //选中的门店点确定后的值列
    const [
      productsChooseItemShowIdDataSubclassNo,
      setProductsChooseItemShowIdDataSubclassNo,
    ] = useState([]); //选中的门店点确定后的值Id
    //Design
    //可用
    const [productsChooseDataIdDesign, setProductsChooseDataIdDesign] =
      useState([]); //选中的门店Id
    const [productsChooseItemDataDesign, setProductsChooseItemDataDesign] =
      useState([]); //存储所有选中数据列
    const [
      productsChooseItemShowDataDesign,
      setProductsChooseItemShowDataDesign,
    ] = useState([]); //选中的门店点确定后的值列
    const [
      productsChooseItemShowIdDataDesign,
      setProductsChooseItemShowIdDataDesign,
    ] = useState([]); //选中的门店点确定后的值Id
    //不可用
    const [productsChooseDataIdDesignNo, setProductsChooseDataIdDesignNo] =
      useState([]); //选中的门店Id
    const [productsChooseItemDataDesignNo, setProductsChooseItemDataDesignNo] =
      useState([]); //存储所有选中数据列
    const [
      productsChooseItemShowDataDesignNo,
      setProductsChooseItemShowDataDesignNo,
    ] = useState([]); //选中的门店点确定后的值列
    const [
      productsChooseItemShowIdDataDesignNo,
      setProductsChooseItemShowIdDataDesignNo,
    ] = useState([]); //选中的门店点确定后的值Id
    const productsNameSubclassRef = useRef(null);
    const productsNameSubclassRefNo = useRef(null);
    const productsNameDesignRef = useRef(null);
    const productsNameDesignRefNo = useRef(null);
    const [productsChooseDataIdGoodsNo, setProductsChooseDataIdGoodsNo] =
      useState([]);
    //Category
    //可用
    const [productsChooseDataIdCategory, setProductsChooseDataIdCategory] =
      useState([]); //选中的门店Id
    const [productsChooseItemDataCategory, setProductsChooseItemDataCategory] =
      useState([]); //存储所有选中数据列
    // 款式产品
    const [productsChooseItemDataStyles, setProductsChooseItemDataStyles] =
      useState([]); //存储所有选中数据列
    const [
      productsChooseItemShowDataCategory,
      setProductsChooseItemShowDataCategory,
    ] = useState([]); //选中的门店点确定后的值列
    const [
      productsChooseItemShowIdDataCategory,
      setProductsChooseItemShowIdDataCategory,
    ] = useState([]); //选中的门店点确定后的值Id
    //不可用
    const [productsChooseDataIdCategoryNo, setProductsChooseDataIdCategoryNo] =
      useState([]); //选中的门店Id
    const [
      productsChooseItemDataCategoryNo,
      setProductsChooseItemDataCategoryNo,
    ] = useState([]); //存储所有选中数据列
    const [
      productsChooseItemShowDataCategoryNo,
      setProductsChooseItemShowDataCategoryNo,
    ] = useState([]); //选中的门店点确定后的值列
    const [
      productsChooseItemShowIdDataCategoryNo,
      setProductsChooseItemShowIdDataCategoryNo,
    ] = useState([]); //选中的门店点确定后的值Id
    const productsNameCategoryRef = useRef(null);
    const productsNameCategoryRefNo = useRef(null);

    const [productType, setProductType] = useState(1);
    //存储点击的是可用商品还是不可用商品的批量导入按钮，1可用，2不可用
    const [importButtonStatus, setImportButtonStatus] = useState();
    //批量导入成功失败的状态监听,ready=>打开导入弹框，start=>点击上传文件按钮，success=>成功，fail=>失败，warning=>有成功有失败
    const [importStatus, setImportStatus] = useState('ready');
    //存储上传成功的数据
    const [uploadSuccessData, setUploadSuccessData] = useState(null);
    //监听批量导入的状态
    const [importFetchStatus, setImportFetchStatus] = useState();

    const {
      stepOneData,
      //可用
      productsList,
      productsName,
      productsTotal,
      productsPageSize,
      productsPageNum,

      productsListSeries,
      productsNameSeries,
      productsTotalSeries,
      productsPageSizeSeries,
      productsPageNumSeries,

      // 款式产品
      productsListStyles,
      productsNameStyles,
      productsTotalStyles,
      productsPageSizeStyles,
      productsPageNumStyles,

      // 货号产品
      productsListGoods,
      productsNameGoods,
      productsTotalGoods,
      productsPageSizeGoods,
      productsPageNumGoods,

      productsListSeason,
      productsNameSeason,
      productsTotalSeason,
      productsPageSizeSeason,
      productsPageNumSeason,

      productsListSubclass,
      productsNameSubclass,
      productsTotalSubclass,
      productsPageSizeSubclass,
      productsPageNumSubclass,

      productsListCategory,
      productsNameCategory,
      productsTotalCategory,
      productsPageSizeCategory,
      productsPageNumCategory,

      productsListDesign,
      productsNameDesign,
      productsTotalDesign,
      productsPageSizeDesign,
      productsPageNumDesign,
      //不可用
    } = useSelector((state) => state.couponsSetting);
    const { ref } = useContext(Context);
    const submitRefThree = useRef();
    const clickInput = () => {
      submitRefThree.current.click();
    };
    useImperativeHandle(ref, () => ({
      // handleSubmit 就是暴露给父组件的方法
      clickInput: clickInput,
    }));
    useEffect(() => {
      setValue('isAllGoods', stepOneData.isAllGoods);
      const defaultProduct = stepOneData.goodsProduct;
      let defaultIds = []; //ids
      if (defaultProduct.length > 0) {
        defaultIds = defaultProduct.map((item) => item.id);
      }
      setProductsChooseDataId(defaultIds);
      setProductsChooseItemShowIdData(defaultIds);
      setProductsChooseItemData(defaultProduct);
      setProductsChooseItemShowData(defaultProduct);
      setValue('goodsProduct', JSON.stringify(defaultProduct));

      const defaultProductNo = stepOneData.goodsProductNo;
      let defaultIdsNo = []; //ids
      if (defaultProductNo.length > 0) {
        defaultIdsNo = defaultProductNo.map((item) => item.id);
      }
      setProductsChooseDataIdNo(defaultIdsNo);
      setProductsChooseItemShowIdDataNo(defaultIdsNo);
      setProductsChooseItemDataNo(defaultProductNo);
      setProductsChooseItemShowDataNo(defaultProductNo);
      setValue('goodsProductNo', JSON.stringify(defaultProductNo));
      //series
      const defaultProductSeries = stepOneData.goodsSeries;
      const defaultProductStyles = stepOneData.goodsStyles;
      const defaultProductGoods = stepOneData.goodsGoods;
      let defaultIdsSeries = []; //ids
      let defaultIdsStyles = [];
      let defaultIdsGoods = [];
      if (defaultProductSeries.length > 0) {
        defaultIdsSeries = defaultProductSeries.map((item) => item.addTypeName);
      }
      if (defaultProductStyles?.length > 0) {
        defaultIdsStyles = defaultProductStyles?.map(
          (item) => item.addTypeName,
        );
      }
      if (defaultProductGoods?.length > 0) {
        defaultIdsGoods = defaultProductGoods?.map((item) => item.addTypeName);
      }
      setProductsChooseDataIdSeries(defaultIdsSeries);
      setProductsChooseItemShowIdDataSeries(defaultIdsSeries);
      setProductsChooseItemDataSeries(defaultProductSeries);
      setProductsChooseItemShowDataSeries(defaultProductSeries);
      // 款号
      setProductsChooseDataIdStyles(defaultIdsStyles);
      setProductsChooseItemShowIdDataStyles(defaultIdsStyles);
      setProductsChooseItemDataStyles(defaultProductStyles);
      setProductsChooseItemShowDataStyles(defaultProductStyles);
      // 货号产品
      setProductsChooseDataIdGoods(defaultIdsGoods);
      setProductsChooseItemShowIdDataGoods(defaultIdsGoods);
      setProductsChooseItemDataGoods(defaultProductGoods);
      setProductsChooseItemShowDataGoods(defaultProductGoods);
      // setProductsChooseItemShowDataDoods(defaultProductSeries);
      setValue('goodsSeries', JSON.stringify(defaultProductSeries));
      setValue('goodsStyles', JSON.stringify(defaultProductStyles));
      setValue('goodsGoods', JSON.stringify(defaultProductGoods));

      const defaultProductSeriesNo = stepOneData.goodsSeriesNo;
      const defaultProductStylesNo = stepOneData.goodsStylesNo;
      const defaultProductGoodsNo = stepOneData.goodsGoodsNo;
      let defaultIdsSeriesNo = []; //ids
      let defaultIdsStylesNo = [];
      let defaultIdsGoodsNo = [];
      if (defaultProductSeriesNo.length > 0) {
        defaultIdsSeriesNo = defaultProductSeriesNo.map(
          (item) => item.addTypeName,
        );
      }
      // 款号
      if (defaultProductStylesNo.length > 0) {
        defaultIdsStylesNo = defaultProductStylesNo.map(
          (item) => item.addTypeName,
        );
      }
      // 货号
      if (defaultProductGoodsNo.length > 0) {
        defaultIdsGoodsNo = defaultProductGoodsNo.map(
          (item) => item.addTypeName,
        );
      }

      setProductsChooseDataIdSeriesNo(defaultIdsSeriesNo);
      setProductsChooseItemShowIdDataSeriesNo(defaultIdsSeriesNo);
      setProductsChooseItemDataSeriesNo(defaultProductSeriesNo);
      setProductsChooseItemShowDataSeriesNo(defaultProductSeriesNo);
      setValue('goodsSeriesNo', JSON.stringify(defaultProductSeriesNo));
      // 款式
      setProductsChooseDataIdStylesNo(defaultIdsStylesNo);
      setProductsChooseItemShowIdDataStylesNo(defaultIdsStylesNo);
      setProductsChooseItemDataStylesNo(defaultProductStylesNo);
      setProductsChooseItemShowDataStylesNo(defaultProductStylesNo);
      setValue('goodsStylesNo', JSON.stringify(defaultProductStylesNo));
      // 货号
      setProductsChooseDataIdGoodsNo(defaultIdsGoodsNo);
      setProductsChooseItemShowIdDataGoodsNo(defaultIdsGoodsNo);
      setProductsChooseItemDataGoodsNo(defaultProductGoodsNo);
      setProductsChooseItemShowDataGoodsNo(defaultProductGoodsNo);
      setValue('goodsGoodsNo', JSON.stringify(defaultProductGoodsNo));
      //Season
      const defaultProductSeason = stepOneData.goodsSeason;
      let defaultIdsSeason = []; //ids
      if (defaultProductSeason.length > 0) {
        defaultIdsSeason = defaultProductSeason.map((item) => item.id);
      }
      setProductsChooseDataIdSeason(defaultIdsSeason);
      setProductsChooseItemShowIdDataSeason(defaultIdsSeason);
      setProductsChooseItemDataSeason(defaultProductSeason);
      setProductsChooseItemShowDataSeason(defaultProductSeason);
      setValue('goodsSeason', JSON.stringify(defaultProductSeason));

      const defaultProductSeasonNo = stepOneData.goodsSeasonNo;
      let defaultIdsSeasonNo = []; //ids
      if (defaultProductSeasonNo.length > 0) {
        defaultIdsSeasonNo = defaultProductSeasonNo.map((item) => item.id);
      }
      setProductsChooseDataIdSeasonNo(defaultIdsSeasonNo);
      setProductsChooseItemShowIdDataSeasonNo(defaultIdsSeasonNo);
      setProductsChooseItemDataSeasonNo(defaultProductSeasonNo);
      setProductsChooseItemShowDataSeasonNo(defaultProductSeasonNo);
      setValue('goodsSeasonNo', JSON.stringify(defaultProductSeasonNo));
      //Subclass
      const defaultProductSubclass = stepOneData.goodsSubclass;
      let defaultIdsSubclass = []; //ids
      if (defaultProductSubclass.length > 0) {
        defaultIdsSubclass = defaultProductSubclass.map((item) => item.id);
      }
      setProductsChooseDataIdSubclass(defaultIdsSubclass);
      setProductsChooseItemShowIdDataSubclass(defaultIdsSubclass);
      setProductsChooseItemDataSubclass(defaultProductSubclass);
      setProductsChooseItemShowDataSubclass(defaultProductSubclass);
      setValue('goodsSubclass', JSON.stringify(defaultProductSubclass));

      const defaultProductSubclassNo = stepOneData.goodsSubclassNo;
      let defaultIdsSubclassNo = []; //ids
      if (defaultProductSubclassNo.length > 0) {
        defaultIdsSubclassNo = defaultProductSubclassNo.map((item) => item.id);
      }
      setProductsChooseDataIdSubclassNo(defaultIdsSubclassNo);
      setProductsChooseItemShowIdDataSubclassNo(defaultIdsSubclassNo);
      setProductsChooseItemDataSubclassNo(defaultProductSubclassNo);
      setProductsChooseItemShowDataSubclassNo(defaultProductSubclassNo);
      setValue('goodsSubclassNo', JSON.stringify(defaultProductSubclassNo));
      //Design
      const defaultProductDesign = stepOneData.goodsDesign;
      let defaultIdsDesign = []; //ids
      if (defaultProductDesign.length > 0) {
        defaultIdsDesign = defaultProductDesign.map((item) => item.id);
      }
      setProductsChooseDataIdDesign(defaultIdsDesign);
      setProductsChooseItemShowIdDataDesign(defaultIdsDesign);
      setProductsChooseItemDataDesign(defaultProductDesign);
      setProductsChooseItemShowDataDesign(defaultProductDesign);
      setValue('goodsDesign', JSON.stringify(defaultProductDesign));

      const defaultProductDesignNo = stepOneData.goodsDesignNo;
      let defaultIdsDesignNo = []; //ids
      if (defaultProductDesignNo.length > 0) {
        defaultIdsDesignNo = defaultProductDesignNo.map((item) => item.id);
      }
      setProductsChooseDataIdDesignNo(defaultIdsDesignNo);
      setProductsChooseItemShowIdDataDesignNo(defaultIdsDesignNo);
      setProductsChooseItemDataDesignNo(defaultProductDesignNo);
      setProductsChooseItemShowDataDesignNo(defaultProductDesignNo);
      setValue('goodsDesignNo', JSON.stringify(defaultProductDesignNo));
      //Category
      const defaultProductCategory = stepOneData.goodsCategory;
      let defaultIdsCategory = []; //ids
      if (defaultProductCategory.length > 0) {
        defaultIdsCategory = defaultProductCategory.map((item) => item.id);
      }
      setProductsChooseDataIdCategory(defaultIdsCategory);
      setProductsChooseItemShowIdDataCategory(defaultIdsCategory);
      setProductsChooseItemDataCategory(defaultProductCategory);
      setProductsChooseItemShowDataCategory(defaultProductCategory);
      setValue('goodsCategory', JSON.stringify(defaultProductCategory));

      const defaultProductCategoryNo = stepOneData.goodsCategoryNo;
      let defaultIdsCategoryNo = []; //ids
      if (defaultProductCategoryNo.length > 0) {
        defaultIdsCategoryNo = defaultProductCategoryNo.map((item) => item.id);
      }
      setProductsChooseDataIdCategoryNo(defaultIdsCategoryNo);
      setProductsChooseItemShowIdDataCategoryNo(defaultIdsCategoryNo);
      setProductsChooseItemDataCategoryNo(defaultProductCategoryNo);
      setProductsChooseItemShowDataCategoryNo(defaultProductCategoryNo);
      setValue('goodsCategoryNo', JSON.stringify(defaultProductCategoryNo));

      setValue('useProduct', stepOneData.useProduct);
      setValue('noUseProduct', stepOneData.noUseProduct);
    }, [
      stepOneData.isAllGoods,
      setValue,
      stepOneData.goodsProduct,
      stepOneData.goodsSeries,
      stepOneData.goodsSeason,
      stepOneData.goodsSubclass,
      stepOneData.goodsCategory,
      stepOneData.goodsProductNo,
      stepOneData.goodsSeriesNo,
      stepOneData.goodsSeasonNo,
      stepOneData.goodsSubclassNo,
      stepOneData.goodsCategoryNo,
      stepOneData.useProduct,
      stepOneData.noUseProduct,
      stepOneData.goodsStyles,
      stepOneData.goodsGoods,
      stepOneData.goodsStylesNo,
      stepOneData.goodsGoodsNo,
      stepOneData.goodsDesign,
      stepOneData.goodsDesignNo,
    ]);
    const deNoUseProduct = stepOneData.noUseProduct;
    const deUseProduct = stepOneData.useProduct;
    let deProductsTypeChooseState = stepOneData.isAllGoods;

    //可用产品的分页
    const handleProductPrevious = () => {
      productPage > 1 && setProductPage(productPage - 1);
    };
    const handleProductDown = () => {
      productsChooseItemShowData.length - productPage * 10 > 0 &&
        setProductPage(productPage + 1);
    };

    //可用系列的分页
    const handleSeriesPrevious = () => {
      seriesPage > 1 && setSeriesPage(seriesPage - 1);
    };
    const handleSeriesDown = () => {
      productsChooseItemShowDataSeries.length - seriesPage * 10 > 0 &&
        setSeriesPage(seriesPage + 1);
    };

    // 可用款式的分页
    const handleStylesPrevious = () => {
      stylesPage > 1 && setStylesPage(stylesPage - 1);
    };
    const handleStylesDown = () => {
      productsChooseItemShowDataStyles.length - stylesPage * 10 > 0 &&
        setStylesPage(stylesPage + 1);
    };

    // 不可用款式分页
    const handleStylesPreviousNo = () => {
      stylesPageNo > 1 && setStylesPageNo(stylesPageNo - 1);
    };
    const handleStylesDownNo = () => {
      productsChooseItemShowDataStylesNo.length - stylesPageNo * 10 > 0 &&
        setStylesPageNo(stylesPageNo + 1);
    };

    // 可用货号的分页
    const handleGoodsPrevious = () => {
      goodsPage > 1 && setGoodsPage(goodsPage - 1);
    };
    const handleGoodsDown = () => {
      productsChooseItemShowDataGoods.length - goodsPage * 10 > 0 &&
        setGoodsPage(goodsPage + 1);
    };

    // 不可用货号的分页
    const handleGoodsPreviousNo = () => {
      goodsPageNo > 1 && setGoodsPageNo(goodsPageNo - 1);
    };
    const handleGoodsDownNo = () => {
      productsChooseItemShowDataGoodsNo.length - goodsPageNo * 10 > 0 &&
        setGoodsPageNo(goodsPageNo + 1);
    };

    //不可用产品的分页
    const handleProductPreviousNo = () => {
      productPageNo > 1 && setProductPageNo(productPageNo - 1);
    };
    const handleProductDownNo = () => {
      productsChooseItemShowDataNo.length - productPageNo * 10 > 0 &&
        setProductPageNo(productPageNo + 1);
    };

    //不可用系列的分页
    const handleSeriesPreviousNo = () => {
      seriesPageNo > 1 && setSeriesPageNo(seriesPageNo - 1);
    };
    const handleSeriesDownNo = () => {
      productsChooseItemShowDataSeriesNo.length - seriesPageNo * 10 > 0 &&
        setSeriesPageNo(seriesPageNo + 1);
    };

    // 季节产品的分页
    const handleSeasonPrevious = () => {
      seasonPage > 1 && setSeasonPage(seasonPage - 1);
    };
    const handleSeasonDown = () => {
      productsChooseItemShowDataSeason?.length - seasonPage * 10 > 0 &&
        setSeasonPage(seasonPage + 1);
    };

    // 大类产品的分页
    const handleSubclassPrevious = () => {
      subclassPage > 1 && setSubclassPage(subclassPage - 1);
    };
    const handleSubclassDown = () => {
      productsChooseItemShowDataSubclass?.length - subclassPage * 10 > 0 &&
        setSubclassPage(subclassPage + 1);
    };
    // 款式的分页
    const handleDesignPrevious = () => {
      designPage > 1 && setDesignPage(designPage - 1);
    };
    const handleDesignDown = () => {
      productsChooseItemShowDataDesign?.length - designPage * 10 > 0 &&
        setDesignPage(designPage + 1);
    };

    // 品类产品的分页
    const handleCategoryPrevious = () => {
      categoryPage > 1 && setCategoryPage(categoryPage - 1);
    };
    const handleCategoryDown = () => {
      productsChooseItemShowDataCategory?.length - categoryPage * 10 > 0 &&
        setCategoryPage(categoryPage + 1);
    };

    // 不可用季节产品的分页
    const handleSeasonPreviousNo = () => {
      seasonPageNo > 1 && setSeasonPageNo(seasonPageNo - 1);
    };
    const handleSeasonDownNo = () => {
      productsChooseItemShowDataSeasonNo?.length - seasonPageNo * 10 > 0 &&
        setSeasonPageNo(seasonPageNo + 1);
    };

    // 不可用大类产品的分页
    const handleSubclassPreviousNo = () => {
      subclassPageNo > 1 && setSubclassPageNo(subclassPageNo - 1);
    };
    const handleSubclassDownNo = () => {
      productsChooseItemShowDataSubclassNo?.length - subclassPageNo * 10 > 0 &&
        setSubclassPageNo(subclassPageNo + 1);
    };
    // 不可用款式的分页
    const handleDesignPreviousNo = () => {
      designPageNo > 1 && setDesignPageNo(designPageNo - 1);
    };
    const handleDesignDownNo = () => {
      productsChooseItemShowDataDesignNo?.length - designPageNo * 10 > 0 &&
        setDesignPageNo(designPageNo + 1);
    };

    // 不可用品类产品的分页
    const handleCategoryPreviousNo = () => {
      categoryPageNo > 1 && setCategoryPageNo(categoryPageNo - 1);
    };
    const handleCategoryDownNo = () => {
      productsChooseItemShowDataCategoryNo?.length - categoryPageNo * 10 > 0 &&
        setCategoryPageNo(categoryPageNo + 1);
    };

    const columns = [
      {
        type: 'checkbox',
        width: '100',
        onChange: (a) => {
          if (productType === 1) {
            const pageDataIds = productsList.map((item) => item.id); //当前分页的id数组
            const prevProductsChooseItemData = productsChooseItemData.filter(
              (item) => {
                //过滤掉当前页的选中列
                return pageDataIds.indexOf(item.id) === -1;
              },
            );

            let chooseDatas = productsList.filter((fItem) => {
              //当前选中的数据过滤出当前页的数据
              return a.includes(fItem.id);
            });

            const newListData = [...prevProductsChooseItemData, ...chooseDatas];
            const newIdsData = newListData.map((item) => item.id);
            //将选中的数据a替换老数据
            setProductsChooseDataId(newIdsData);
            setProductsChooseItemData(newListData);
            return;
          }
          const pageDataIdsNo = productsList.map((item) => item.id); //当前分页的id数组
          const prevProductsChooseItemDataNo = productsChooseItemDataNo.filter(
            (item) => {
              //过滤掉当前页的选中列
              return pageDataIdsNo.indexOf(item.id) === -1;
            },
          );
          let chooseDatasNo = productsList.filter((fItem) => {
            //当前选中的数据过滤出当前页的数据
            return a.includes(fItem.id);
          });

          const newListDataNo = [
            ...prevProductsChooseItemDataNo,
            ...chooseDatasNo,
          ];
          const newIdsDataNo = newListDataNo.map((item) => item.id);
          //将选中的数据a替换老数据
          setProductsChooseDataIdNo(newIdsDataNo);
          setProductsChooseItemDataNo(newListDataNo);
        },
      },
      {
        title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt77' }),
        id: 'productNo',
        align: 'center',
        width: 347,
      },
      {
        title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt78' }),
        id: 'name',
        align: 'center',
        width: 347,
        render: (item) => {
          return <Box textAlign="center">{item.name}</Box>;
        },
      },
    ];
    const columnsTabData = [
      {
        type: 'checkbox',
        width: '100',
        onChange: (a) => {
          if (productType === 1) {
            if (value === 3) {
              //当前页列表数据
              const pageDataIdsSeries = productsListSeries.map(
                (item) => item.addTypeName,
              ); //当前分页的id数组
              const prevProductsChooseItemDataSeries =
                productsChooseItemDataSeries.filter((item) => {
                  //过滤掉当前页的选中列
                  return pageDataIdsSeries.indexOf(item.addTypeName) === -1;
                });

              let chooseDatasSeries = productsListSeries.filter((fItem) => {
                //当前选中的数据过滤出当前页的数据
                return a.includes(fItem.addTypeName);
              });

              const newListData = [
                ...prevProductsChooseItemDataSeries,
                ...chooseDatasSeries,
              ];
              const newIdsData = newListData.map((item) => item.addTypeName);
              //将选中的数据a替换老数据
              setProductsChooseDataIdSeries(newIdsData);
              setProductsChooseItemDataSeries(newListData);
              return;
            } else if (value === 4) {
              const pageDataIdsSeason = productsListSeason.map(
                (item) => item.id,
              ); //当前分页的id数组
              const prevProductsChooseItemDataSeason =
                productsChooseItemDataSeason.filter((item) => {
                  //过滤掉当前页的选中列
                  return pageDataIdsSeason.indexOf(item.id) === -1;
                });

              let chooseDatasSeason = productsListSeason.filter((fItem) => {
                //当前选中的数据过滤出当前页的数据
                return a.includes(fItem.id);
              });

              const newListData = [
                ...prevProductsChooseItemDataSeason,
                ...chooseDatasSeason,
              ];
              const newIdsData = newListData.map((item) => item.id);
              //将选中的数据a替换老数据
              setProductsChooseDataIdSeason(newIdsData);
              setProductsChooseItemDataSeason(newListData);
            } else if (value === 5) {
              const pageDataIdsDesign = productsListDesign.map(
                (item) => item.id,
              ); //当前分页的id数组
              const prevProductsChooseItemDataDesign =
                productsChooseItemDataDesign.filter((item) => {
                  //过滤掉当前页的选中列
                  return pageDataIdsDesign.indexOf(item.id) === -1;
                });

              let chooseDatasDesign = productsListDesign.filter((fItem) => {
                //当前选中的数据过滤出当前页的数据
                return a.includes(fItem.id);
              });

              const newListData = [
                ...prevProductsChooseItemDataDesign,
                ...chooseDatasDesign,
              ];
              const newIdsData = newListData.map((item) => item.id);
              //将选中的数据a替换老数据
              setProductsChooseDataIdDesign(newIdsData);
              setProductsChooseItemDataDesign(newListData);
            } else if (value === 6) {
              const pageDataIdsSubclass = productsListSubclass.map(
                (item) => item.id,
              ); //当前分页的id数组
              const prevProductsChooseItemDataSubclass =
                productsChooseItemDataSubclass.filter((item) => {
                  //过滤掉当前页的选中列
                  return pageDataIdsSubclass.indexOf(item.id) === -1;
                });

              let chooseDatasSubclass = productsListSubclass.filter((fItem) => {
                //当前选中的数据过滤出当前页的数据
                return a.includes(fItem.id);
              });

              const newListData = [
                ...prevProductsChooseItemDataSubclass,
                ...chooseDatasSubclass,
              ];
              const newIdsData = newListData.map((item) => item.id);
              //将选中的数据a替换老数据
              setProductsChooseDataIdSubclass(newIdsData);
              setProductsChooseItemDataSubclass(newListData);
            } else if (value === 7) {
              const pageDataIdsCategory = productsListCategory.map(
                (item) => item.id,
              ); //当前分页的id数组
              const prevProductsChooseItemDataCategory =
                productsChooseItemDataCategory.filter((item) => {
                  //过滤掉当前页的选中列
                  return pageDataIdsCategory.indexOf(item.id) === -1;
                });

              let chooseDatasCategory = productsListCategory.filter((fItem) => {
                //当前选中的数据过滤出当前页的数据
                return a.includes(fItem.id);
              });

              const newListData = [
                ...prevProductsChooseItemDataCategory,
                ...chooseDatasCategory,
              ];
              const newIdsData = newListData.map((item) => item.id);
              //将选中的数据a替换老数据
              setProductsChooseDataIdCategory(newIdsData);
              setProductsChooseItemDataCategory(newListData);
            } else if (value === 0) {
              const pageDataIdsStyles = productsListStyles.map(
                (item) => item.addTypeName,
              ); //当前分页的id数组
              const prevProductsChooseItemDataStyles =
                productsChooseItemDataStyles.filter((item) => {
                  //过滤掉当前页的选中列
                  return pageDataIdsStyles.indexOf(item.addTypeName) === -1;
                });

              let chooseDatasStyles = productsListStyles?.filter((fItem) => {
                //当前选中的数据过滤出当前页的数据
                return a.includes(fItem.addTypeName);
              });

              const newListData = [
                ...prevProductsChooseItemDataStyles,
                ...chooseDatasStyles,
              ];
              const newIdsData = newListData.map((item) => item.addTypeName);
              //将选中的数据a替换老数据
              setProductsChooseDataIdStyles(newIdsData);
              setProductsChooseItemDataStyles(newListData);
            } else if (value === 1) {
              const pageDataIdsGoods = productsListGoods.map(
                (item) => item.addTypeName,
              ); //当前分页的id数组
              const prevProductsChooseItemDataGoods =
                productsChooseItemDataGoods.filter((item) => {
                  //过滤掉当前页的选中列
                  return pageDataIdsGoods.indexOf(item.addTypeName) === -1;
                });
              let chooseDatasGoods = productsListGoods?.filter((fItem) => {
                //当前选中的数据过滤出当前页的数据
                return a.includes(fItem.addTypeName);
              });
              const newListData = [
                ...prevProductsChooseItemDataGoods,
                ...chooseDatasGoods,
              ];
              const newIdsData = newListData.map((item) => item.addTypeName);
              //将选中的数据a替换老数据
              setProductsChooseDataIdGoods(newIdsData);
              setProductsChooseItemDataGoods(newListData);
            }
            return;
          }
          if (value === 3) {
            const pageDataIdsSeriesNo = productsListSeries.map(
              (item) => item.addTypeName,
            ); //当前分页的id数组
            const prevProductsChooseItemDataSeriesNo =
              productsChooseItemDataSeriesNo.filter((item) => {
                //过滤掉当前页的选中列
                return pageDataIdsSeriesNo.indexOf(item.addTypeName) === -1;
              });

            let chooseDatasSeriesNo = productsListSeries.filter((fItem) => {
              //当前选中的数据过滤出当前页的数据
              return a.includes(fItem.addTypeName);
            });

            const newListDataNo = [
              ...prevProductsChooseItemDataSeriesNo,
              ...chooseDatasSeriesNo,
            ];
            const newIdsData = newListDataNo.map((item) => item.addTypeName);
            //将选中的数据a替换老数据
            setProductsChooseDataIdSeriesNo(newIdsData);
            setProductsChooseItemDataSeriesNo(newListDataNo);
            return;
          } else if (value === 4) {
            const pageDataIdsSeasonNo = productsListSeason.map(
              (item) => item.id,
            ); //当前分页的id数组
            const prevProductsChooseItemDataSeasonNo =
              productsChooseItemDataSeasonNo.filter((item) => {
                //过滤掉当前页的选中列
                return pageDataIdsSeasonNo.indexOf(item.id) === -1;
              });

            let chooseDatasSeasonNo = productsListSeason.filter((fItem) => {
              //当前选中的数据过滤出当前页的数据
              return a.includes(fItem.id);
            });

            const newListDataNo = [
              ...prevProductsChooseItemDataSeasonNo,
              ...chooseDatasSeasonNo,
            ];
            const newIdsData = newListDataNo.map((item) => item.id);
            //将选中的数据a替换老数据
            setProductsChooseDataIdSeasonNo(newIdsData);
            setProductsChooseItemDataSeasonNo(newListDataNo);
          } else if (value === 5) {
            const pageDataIdsDesignNo = productsListDesign.map(
              (item) => item.id,
            ); //当前分页的id数组
            const prevProductsChooseItemDataDesignNo =
              productsChooseItemDataDesignNo.filter((item) => {
                //过滤掉当前页的选中列
                return pageDataIdsDesignNo.indexOf(item.id) === -1;
              });

            let chooseDatasDesignNo = productsListDesign.filter((fItem) => {
              //当前选中的数据过滤出当前页的数据
              return a.includes(fItem.id);
            });

            const newListDataNo = [
              ...prevProductsChooseItemDataDesignNo,
              ...chooseDatasDesignNo,
            ];
            const newIdsData = newListDataNo.map((item) => item.id);
            //将选中的数据a替换老数据
            setProductsChooseDataIdDesignNo(newIdsData);
            setProductsChooseItemDataDesignNo(newListDataNo);
          } else if (value === 6) {
            const pageDataIdsSubclassNo = productsListSubclass.map(
              (item) => item.id,
            ); //当前分页的id数组
            const prevProductsChooseItemDataSubclassNo =
              productsChooseItemDataSubclassNo.filter((item) => {
                //过滤掉当前页的选中列
                return pageDataIdsSubclassNo.indexOf(item.id) === -1;
              });

            let chooseDatasSubclassNo = productsListSubclass.filter((fItem) => {
              //当前选中的数据过滤出当前页的数据
              return a.includes(fItem.id);
            });

            const newListDataNo = [
              ...prevProductsChooseItemDataSubclassNo,
              ...chooseDatasSubclassNo,
            ];
            const newIdsData = newListDataNo.map((item) => item.id);
            //将选中的数据a替换老数据
            setProductsChooseDataIdSubclassNo(newIdsData);
            setProductsChooseItemDataSubclassNo(newListDataNo);
          } else if (value === 7) {
            const pageDataIdsCategoryNo = productsListCategory.map(
              (item) => item.id,
            ); //当前分页的id数组
            const prevProductsChooseItemDataCategoryNo =
              productsChooseItemDataCategoryNo.filter((item) => {
                //过滤掉当前页的选中列
                return pageDataIdsCategoryNo.indexOf(item.id) === -1;
              });

            let chooseDatasCategoryNo = productsListCategory.filter((fItem) => {
              //当前选中的数据过滤出当前页的数据
              return a.includes(fItem.id);
            });

            const newListDataNo = [
              ...prevProductsChooseItemDataCategoryNo,
              ...chooseDatasCategoryNo,
            ];
            const newIdsData = newListDataNo.map((item) => item.id);
            //将选中的数据a替换老数据
            setProductsChooseDataIdCategoryNo(newIdsData);
            setProductsChooseItemDataCategoryNo(newListDataNo);
          } else if (value === 0) {
            const pageDataIdsStylesNo = productsListStyles.map(
              (item) => item.addTypeName,
            ); //当前分页的id数组
            const prevProductsChooseItemDataStylesNo =
              productsChooseItemDataStylesNo.filter((item) => {
                //过滤掉当前页的选中列
                return pageDataIdsStylesNo.indexOf(item.addTypeName) === -1;
              });

            let chooseDatasStylesNo = productsListStyles.filter((fItem) => {
              //当前选中的数据过滤出当前页的数据
              return a.includes(fItem.addTypeName);
            });

            const newListDataNo = [
              ...prevProductsChooseItemDataStylesNo,
              ...chooseDatasStylesNo,
            ];
            const newIdsData = newListDataNo.map((item) => item.addTypeName);
            //将选中的数据a替换老数据
            setProductsChooseDataIdStylesNo(newIdsData);
            setProductsChooseItemDataStylesNo(newListDataNo);
          } else if (value === 1) {
            const pageDataIdsGoodsNo = productsListGoods.map(
              (item) => item.addTypeName,
            ); //当前分页的id数组
            const prevProductsChooseItemDataGoodsNo =
              productsChooseItemDataGoodsNo.filter((item) => {
                //过滤掉当前页的选中列
                return pageDataIdsGoodsNo.indexOf(item.addTypeName) === -1;
              });

            let chooseDatasGoodsNo = productsListGoods?.filter((fItem) => {
              //当前选中的数据过滤出当前页的数据
              return a.includes(fItem.addTypeName);
            });

            const newListDataNo = [
              ...prevProductsChooseItemDataGoodsNo,
              ...chooseDatasGoodsNo,
            ];
            const newIdsData = newListDataNo.map((item) => item.addTypeName);
            //将选中的数据a替换老数据
            setProductsChooseDataIdGoodsNo(newIdsData);
            setProductsChooseItemDataGoodsNo(newListDataNo);
          }
        },
      },
      {
        // title: value === 3 || value === 0 || value === 1 ? '编码' : 'CODE',
        title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt77' }),
        id:
          value === 0 || value === 1
            ? 'addTypeName'
            : value === 3
            ? 'name'
            : 'id',
        align: 'center',
        width: 347,
      },
      {
        title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt78' }),
        id: value === 3 || value === 0 || value === 1 ? 'addTypeName' : 'name',
        align: 'center',
        width: 347,
        render: (item) => {
          return <Box textAlign="center">{item.name}</Box>;
        },
      },
    ];
    const showColumns = [
      {
        title: 'SKU',
        id: 'productNo',
        align: 'center',
        width: 150,
      },
      {
        title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt79' }),
        id: 'name',
        align: 'center',
        width: 460,
      },
      {
        title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt65' }),
        align: 'center',
        id: 'details',
        width: 100,
        render: (items) => {
          return (
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                lineHeight: '64px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  lineHeight: '64px',
                  cursor: 'pointer',
                }}
              >
                <ButtonTip title={formatMessage({ id: 'comm.action.btn.04' })}>
                  <IconButton>
                    <DeleteForeverOutlinedIcon
                      style={{
                        fontSize: '20px',
                        color: queryType === 'detail' ? 'darkgray' : '#525CA3',
                      }}
                      onClick={() => {
                        setProductType(1);
                        queryType !== 'detail' &&
                          handleDeleteProducts(items.id, 1);
                      }}
                    ></DeleteForeverOutlinedIcon>
                  </IconButton>
                </ButtonTip>
              </div>
            </div>
          );
        },
      },
    ];
    const showColumnsNo = [
      {
        title: 'SKU',
        id: 'productNo',
        align: 'center',
        width: 150,
      },
      {
        title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt79' }),
        id: 'name',
        align: 'center',
        width: 460,
      },
      {
        title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt65' }),
        align: 'center',
        id: 'details',
        width: 100,
        render: (items) => {
          return (
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                lineHeight: '64px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  lineHeight: '64px',
                  cursor: 'pointer',
                }}
              >
                <ButtonTip title={formatMessage({ id: 'comm.action.btn.04' })}>
                  <IconButton>
                    <DeleteForeverOutlinedIcon
                      style={{
                        fontSize: '20px',
                        color: queryType === 'detail' ? 'darkgray' : '#525CA3',
                      }}
                      onClick={() => {
                        setProductType(2);
                        queryType !== 'detail' &&
                          handleDeleteProducts(items.id, 2);
                      }}
                    ></DeleteForeverOutlinedIcon>
                  </IconButton>
                </ButtonTip>
              </div>
            </div>
          );
        },
      },
    ];
    const showColumnsTabData = [
      {
        title:
          valueChoose === 3 || valueChoose === 0 || valueChoose === 1
            ? formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt80' })
            : 'CODE',
        // id:
        //   valueChoose === 3 || valueChoose === 0 || valueChoose === 1
        //     ? 'addTypeName'
        //     : 'id',
        id:
          valueChoose === 0 || valueChoose === 1
            ? 'addTypeName'
            : valueChoose === 3
            ? 'name'
            : 'id',
        align: 'center',
        width: 150,
      },
      {
        title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt79' }),
        // id:
        //   valueChoose === 3 || valueChoose === 0 || valueChoose === 1
        //     ? 'addTypeName'
        //     : 'name',
        id: 'name',
        align: 'center',
        width: 460,
      },
      {
        title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt65' }),
        align: 'center',
        id: 'details',
        width: 100,
        render: (items) => {
          return (
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                lineHeight: '64px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  lineHeight: '64px',
                  cursor: 'pointer',
                }}
              >
                <ButtonTip title={formatMessage({ id: 'comm.action.btn.04' })}>
                  <IconButton>
                    <DeleteForeverOutlinedIcon
                      style={{
                        fontSize: '20px',
                        color: queryType === 'detail' ? 'darkgray' : '#525CA3',
                      }}
                      onClick={() => {
                        setProductType(1);
                        queryType !== 'detail' &&
                          handleDeleteProductsSeries(
                            valueChoose === 3 ||
                              valueChoose === 0 ||
                              valueChoose === 1
                              ? items.addTypeName
                              : items.id,
                            1,
                          );
                      }}
                    ></DeleteForeverOutlinedIcon>
                  </IconButton>
                </ButtonTip>
              </div>
            </div>
          );
        },
      },
    ];
    const showColumnsTabDataNo = [
      {
        title:
          valueChooseNo === 3 || valueChooseNo === 0 || valueChooseNo === 1
            ? formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt80' })
            : 'CODE',
        id:
          valueChooseNo === 0 || valueChooseNo === 1
            ? 'addTypeName'
            : valueChooseNo === 3
            ? 'name'
            : 'id',
        align: 'center',
        width: 150,
      },
      {
        title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt79' }),
        // id:
        //   valueChooseNo === 3 || valueChooseNo === 0 || valueChooseNo === 1
        //     ? 'addTypeName'
        //     : 'name',
        id: 'name',
        align: 'center',
        width: 460,
      },
      {
        title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt65' }),
        align: 'center',
        id: 'details',
        width: 100,
        render: (items) => {
          return (
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                lineHeight: '64px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  lineHeight: '64px',
                  cursor: 'pointer',
                }}
              >
                <ButtonTip title={formatMessage({ id: 'comm.action.btn.04' })}>
                  <DeleteForeverOutlinedIcon
                    style={{
                      fontSize: '20px',
                      color: queryType === 'detail' ? 'darkgray' : '#525CA3',
                    }}
                    onClick={() => {
                      setProductType(2);
                      queryType !== 'detail' &&
                        handleDeleteProductsSeries(
                          valueChooseNo === 3 ||
                            valueChooseNo === 0 ||
                            valueChooseNo === 1
                            ? items.addTypeName
                            : items.id,
                          2,
                        );
                    }}
                  ></DeleteForeverOutlinedIcon>
                </ButtonTip>
              </div>
            </div>
          );
        },
      },
    ];
    //点击删除已经选中的门店
    const handleDeleteProducts = (id, type) => {
      if (type === 1) {
        const prevProductsChooseDataId = productsChooseDataId.filter((item) => {
          return item !== id;
        });
        const prevProductsChooseItemData = productsChooseItemData.filter(
          (item) => {
            return item.id !== id;
          },
        );
        const prevProductsChooseItemShowData =
          productsChooseItemShowData.filter((item) => {
            return item.id !== id;
          });
        const prevProductsChooseItemShowIdData =
          productsChooseItemShowIdData.filter((item) => {
            return item !== id;
          });
        setProductsChooseDataId(prevProductsChooseDataId);
        setProductsChooseItemData(prevProductsChooseItemData);
        setProductsChooseItemShowData(prevProductsChooseItemShowData);
        setProductsChooseItemShowIdData(prevProductsChooseItemShowIdData);
        setValue(
          'goodsProduct',
          (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
            ? JSON.stringify(prevProductsChooseItemShowData)
            : '',
        );
        return;
      }
      const prevProductsChooseDataIdNo = productsChooseDataIdNo.filter(
        (item) => {
          return item !== id;
        },
      );
      const prevProductsChooseItemDataNo = productsChooseItemDataNo.filter(
        (item) => {
          return item.id !== id;
        },
      );
      const prevProductsChooseItemShowDataNo =
        productsChooseItemShowDataNo.filter((item) => {
          return item.id !== id;
        });
      const prevProductsChooseItemShowIdDataNo =
        productsChooseItemShowIdDataNo.filter((item) => {
          return item !== id;
        });
      setProductsChooseDataIdNo(prevProductsChooseDataIdNo);
      setProductsChooseItemDataNo(prevProductsChooseItemDataNo);
      setProductsChooseItemShowDataNo(prevProductsChooseItemShowDataNo);
      setProductsChooseItemShowIdDataNo(prevProductsChooseItemShowIdDataNo);
      setValue(
        'goodsProductNo',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(prevProductsChooseItemShowDataNo)
          : '',
      );
    };
    //点击删除已经选中的门店
    const handleDeleteProductsSeries = (addTypeName, type) => {
      if (type === 1) {
        if (valueChoose === 3) {
          const prevProductsChooseDataIdSeries =
            productsChooseDataIdSeries.filter((item) => {
              return item !== addTypeName;
            });
          const prevProductsChooseItemDataSeries =
            productsChooseItemDataSeries.filter((item) => {
              return item.addTypeName !== addTypeName;
            });
          const prevProductsChooseItemShowDataSeries =
            productsChooseItemShowDataSeries.filter((item) => {
              return item.addTypeName !== addTypeName;
            });
          const prevProductsChooseItemShowIdDataSeries =
            productsChooseItemShowIdDataSeries.filter((item) => {
              return item !== addTypeName;
            });
          setProductsChooseDataIdSeries(prevProductsChooseDataIdSeries);
          setProductsChooseItemDataSeries(prevProductsChooseItemDataSeries);
          setProductsChooseItemShowDataSeries(
            prevProductsChooseItemShowDataSeries,
          );
          setProductsChooseItemShowIdDataSeries(
            prevProductsChooseItemShowIdDataSeries,
          );
          setValue(
            'goodsSeries',
            (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
              ? JSON.stringify(prevProductsChooseItemShowDataSeries)
              : '',
          );
          return;
        } else if (valueChoose === 4) {
          const prevProductsChooseDataIdSeason =
            productsChooseDataIdSeason.filter((item) => {
              return item !== addTypeName;
            });
          const prevProductsChooseItemDataSeason =
            productsChooseItemDataSeason.filter((item) => {
              return item.id !== addTypeName;
            });
          const prevProductsChooseItemShowDataSeason =
            productsChooseItemShowDataSeason.filter((item) => {
              return item.id !== addTypeName;
            });
          const prevProductsChooseItemShowIdDataSeason =
            productsChooseItemShowIdDataSeason.filter((item) => {
              return item !== addTypeName;
            });
          setProductsChooseDataIdSeason(prevProductsChooseDataIdSeason);
          setProductsChooseItemDataSeason(prevProductsChooseItemDataSeason);
          setProductsChooseItemShowDataSeason(
            prevProductsChooseItemShowDataSeason,
          );
          setProductsChooseItemShowIdDataSeason(
            prevProductsChooseItemShowIdDataSeason,
          );
          setValue(
            'goodsSeason',
            (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
              ? JSON.stringify(prevProductsChooseItemShowDataSeason)
              : '',
          );
          return;
        } else if (valueChoose === 5) {
          const prevProductsChooseDataIdDesign =
            productsChooseDataIdDesign.filter((item) => {
              return item !== addTypeName;
            });
          const prevProductsChooseItemDataDesign =
            productsChooseItemDataDesign.filter((item) => {
              return item.id !== addTypeName;
            });
          const prevProductsChooseItemShowDataDesign =
            productsChooseItemShowDataDesign.filter((item) => {
              return item.id !== addTypeName;
            });
          const prevProductsChooseItemShowIdDataDesign =
            productsChooseItemShowIdDataDesign.filter((item) => {
              return item !== addTypeName;
            });
          setProductsChooseDataIdDesign(prevProductsChooseDataIdDesign);
          setProductsChooseItemDataDesign(prevProductsChooseItemDataDesign);
          setProductsChooseItemShowDataDesign(
            prevProductsChooseItemShowDataDesign,
          );
          setProductsChooseItemShowIdDataDesign(
            prevProductsChooseItemShowIdDataDesign,
          );
          // ----------
          setValue(
            'goodsDesign',
            (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
              ? JSON.stringify(prevProductsChooseItemShowDataDesign)
              : '',
          );
          return;
        } else if (valueChoose === 6) {
          const prevProductsChooseDataIdSubclass =
            productsChooseDataIdSubclass.filter((item) => {
              return item !== addTypeName;
            });
          const prevProductsChooseItemDataSubclass =
            productsChooseItemDataSubclass.filter((item) => {
              return item.id !== addTypeName;
            });
          const prevProductsChooseItemShowDataSubclass =
            productsChooseItemShowDataSubclass.filter((item) => {
              return item.id !== addTypeName;
            });
          const prevProductsChooseItemShowIdDataSubclass =
            productsChooseItemShowIdDataSubclass.filter((item) => {
              return item !== addTypeName;
            });
          setProductsChooseDataIdSubclass(prevProductsChooseDataIdSubclass);
          setProductsChooseItemDataSubclass(prevProductsChooseItemDataSubclass);
          setProductsChooseItemShowDataSubclass(
            prevProductsChooseItemShowDataSubclass,
          );
          setProductsChooseItemShowIdDataSubclass(
            prevProductsChooseItemShowIdDataSubclass,
          );
          setValue(
            'goodsSubclass',
            (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
              ? JSON.stringify(prevProductsChooseItemShowDataSubclass)
              : '',
          );
          return;
        } else if (valueChoose === 7) {
          const prevProductsChooseDataIdCategory =
            productsChooseDataIdCategory.filter((item) => {
              return item !== addTypeName;
            });
          const prevProductsChooseItemDataCategory =
            productsChooseItemDataCategory.filter((item) => {
              return item.id !== addTypeName;
            });
          const prevProductsChooseItemShowDataCategory =
            productsChooseItemShowDataCategory.filter((item) => {
              return item.id !== addTypeName;
            });
          const prevProductsChooseItemShowIdDataCategory =
            productsChooseItemShowIdDataCategory.filter((item) => {
              return item !== addTypeName;
            });
          setProductsChooseDataIdCategory(prevProductsChooseDataIdCategory);
          setProductsChooseItemDataCategory(prevProductsChooseItemDataCategory);
          setProductsChooseItemShowDataCategory(
            prevProductsChooseItemShowDataCategory,
          );
          setProductsChooseItemShowIdDataCategory(
            prevProductsChooseItemShowIdDataCategory,
          );
          setValue(
            'goodsCategory',
            (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
              ? JSON.stringify(prevProductsChooseItemShowDataCategory)
              : '',
          );
          return;
        } else if (valueChoose === 0) {
          const prevProductsChooseDataIdStyles =
            productsChooseDataIdStyles.filter((item) => {
              return item !== addTypeName;
            });
          const prevProductsChooseItemDataStyles =
            productsChooseItemDataStyles.filter((item) => {
              return item.addTypeName !== addTypeName;
            });
          const prevProductsChooseItemShowDataStyles =
            productsChooseItemShowDataStyles.filter((item) => {
              return item.addTypeName !== addTypeName;
            });
          const prevProductsChooseItemShowIdDataStyles =
            productsChooseItemShowIdDataStyles.filter((item) => {
              return item !== addTypeName;
            });
          setProductsChooseDataIdStyles(prevProductsChooseDataIdStyles);
          setProductsChooseItemDataStyles(prevProductsChooseItemDataStyles);
          setProductsChooseItemShowDataStyles(
            prevProductsChooseItemShowDataStyles,
          );
          setProductsChooseItemShowIdDataStyles(
            prevProductsChooseItemShowIdDataStyles,
          );
          setValue(
            'goodsStyles',
            (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
              ? JSON.stringify(prevProductsChooseItemShowDataStyles)
              : '',
          );
          return;
        } else if (valueChoose === 1) {
          const prevProductsChooseDataIdGoods =
            productsChooseDataIdGoods.filter((item) => {
              return item !== addTypeName;
            });
          const prevProductsChooseItemDataGoods =
            productsChooseItemDataGoods.filter((item) => {
              return item.addTypeName !== addTypeName;
            });
          const prevProductsChooseItemShowDataGoods =
            productsChooseItemShowDataGoods.filter((item) => {
              return item.addTypeName !== addTypeName;
            });
          const prevProductsChooseItemShowIdDataGoods =
            productsChooseItemShowIdDataGoods.filter((item) => {
              return item !== addTypeName;
            });
          setProductsChooseDataIdGoods(prevProductsChooseDataIdGoods);
          setProductsChooseItemDataGoods(prevProductsChooseItemDataGoods);
          setProductsChooseItemShowDataGoods(
            prevProductsChooseItemShowDataGoods,
          );
          setProductsChooseItemShowIdDataGoods(
            prevProductsChooseItemShowIdDataGoods,
          );
          setValue(
            'goodsGoods',
            (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
              ? JSON.stringify(prevProductsChooseItemShowDataGoods)
              : '',
          );
          return;
        }
        return;
      }

      if (valueChooseNo === 3) {
        const prevProductsChooseDataIdSeriesNo =
          productsChooseDataIdSeriesNo.filter((item) => {
            return item !== addTypeName;
          });
        const prevProductsChooseItemDataSeriesNo =
          productsChooseItemDataSeriesNo.filter((item) => {
            return item.addTypeName !== addTypeName;
          });
        const prevProductsChooseItemShowDataSeriesNo =
          productsChooseItemShowDataSeriesNo.filter((item) => {
            return item.addTypeName !== addTypeName;
          });
        const prevProductsChooseItemShowIdDataSeriesNo =
          productsChooseItemShowIdDataSeriesNo.filter((item) => {
            return item !== addTypeName;
          });
        setProductsChooseDataIdSeriesNo(prevProductsChooseDataIdSeriesNo);
        setProductsChooseItemDataSeriesNo(prevProductsChooseItemDataSeriesNo);
        setProductsChooseItemShowDataSeriesNo(
          prevProductsChooseItemShowDataSeriesNo,
        );
        setProductsChooseItemShowIdDataSeriesNo(
          prevProductsChooseItemShowIdDataSeriesNo,
        );
        setValue(
          'goodsSeriesNo',
          (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
            ? JSON.stringify(prevProductsChooseItemShowDataSeriesNo)
            : '',
        );
        return;
      } else if (valueChooseNo === 4) {
        const prevProductsChooseDataIdSeasonNo =
          productsChooseDataIdSeasonNo.filter((item) => {
            return item !== addTypeName;
          });
        const prevProductsChooseItemDataSeasonNo =
          productsChooseItemDataSeasonNo.filter((item) => {
            return item.id !== addTypeName;
          });
        const prevProductsChooseItemShowDataSeasonNo =
          productsChooseItemShowDataSeasonNo.filter((item) => {
            return item.id !== addTypeName;
          });
        const prevProductsChooseItemShowIdDataSeasonNo =
          productsChooseItemShowIdDataSeasonNo.filter((item) => {
            return item !== addTypeName;
          });
        setProductsChooseDataIdSeasonNo(prevProductsChooseDataIdSeasonNo);
        setProductsChooseItemDataSeasonNo(prevProductsChooseItemDataSeasonNo);
        setProductsChooseItemShowDataSeasonNo(
          prevProductsChooseItemShowDataSeasonNo,
        );
        setProductsChooseItemShowIdDataSeasonNo(
          prevProductsChooseItemShowIdDataSeasonNo,
        );
        setValue(
          'goodsSeasonNo',
          (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
            ? JSON.stringify(prevProductsChooseItemShowDataSeasonNo)
            : '',
        );
        return;
      } else if (valueChooseNo === 5) {
        const prevProductsChooseDataIdDesignNo =
          productsChooseDataIdDesignNo.filter((item) => {
            return item !== addTypeName;
          });
        const prevProductsChooseItemDataDesignNo =
          productsChooseItemDataDesignNo.filter((item) => {
            return item.id !== addTypeName;
          });
        const prevProductsChooseItemShowDataDesignNo =
          productsChooseItemShowDataDesignNo.filter((item) => {
            return item.id !== addTypeName;
          });
        const prevProductsChooseItemShowIdDataDesignNo =
          productsChooseItemShowIdDataDesignNo.filter((item) => {
            return item !== addTypeName;
          });
        setProductsChooseDataIdDesignNo(prevProductsChooseDataIdDesignNo);
        setProductsChooseItemDataDesignNo(prevProductsChooseItemDataDesignNo);
        setProductsChooseItemShowDataDesignNo(
          prevProductsChooseItemShowDataDesignNo,
        );
        setProductsChooseItemShowIdDataDesignNo(
          prevProductsChooseItemShowIdDataDesignNo,
        );
        // ---------------
        setValue(
          'goodsDesignNo',
          (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
            ? JSON.stringify(prevProductsChooseItemShowDataDesignNo)
            : '',
        );
        return;
      } else if (valueChooseNo === 6) {
        const prevProductsChooseDataIdSubclassNo =
          productsChooseDataIdSubclassNo.filter((item) => {
            return item !== addTypeName;
          });
        const prevProductsChooseItemDataSubclassNo =
          productsChooseItemDataSubclassNo.filter((item) => {
            return item.id !== addTypeName;
          });
        const prevProductsChooseItemShowDataSubclassNo =
          productsChooseItemShowDataSubclassNo.filter((item) => {
            return item.id !== addTypeName;
          });
        const prevProductsChooseItemShowIdDataSubclassNo =
          productsChooseItemShowIdDataSubclassNo.filter((item) => {
            return item !== addTypeName;
          });
        setProductsChooseDataIdSubclassNo(prevProductsChooseDataIdSubclassNo);
        setProductsChooseItemDataSubclassNo(
          prevProductsChooseItemDataSubclassNo,
        );
        setProductsChooseItemShowDataSubclassNo(
          prevProductsChooseItemShowDataSubclassNo,
        );
        setProductsChooseItemShowIdDataSubclassNo(
          prevProductsChooseItemShowIdDataSubclassNo,
        );
        setValue(
          'goodsSubclassNo',
          (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
            ? JSON.stringify(prevProductsChooseItemShowDataSubclassNo)
            : '',
        );
        return;
      } else if (valueChooseNo === 7) {
        const prevProductsChooseDataIdCategoryNo =
          productsChooseDataIdCategoryNo.filter((item) => {
            return item !== addTypeName;
          });
        const prevProductsChooseItemDataCategoryNo =
          productsChooseItemDataCategoryNo.filter((item) => {
            return item.id !== addTypeName;
          });
        const prevProductsChooseItemShowDataCategoryNo =
          productsChooseItemShowDataCategoryNo.filter((item) => {
            return item.id !== addTypeName;
          });
        const prevProductsChooseItemShowIdDataCategoryNo =
          productsChooseItemShowIdDataCategoryNo.filter((item) => {
            return item !== addTypeName;
          });
        setProductsChooseDataIdCategoryNo(prevProductsChooseDataIdCategoryNo);
        setProductsChooseItemDataCategoryNo(
          prevProductsChooseItemDataCategoryNo,
        );
        setProductsChooseItemShowDataCategoryNo(
          prevProductsChooseItemShowDataCategoryNo,
        );
        setProductsChooseItemShowIdDataCategoryNo(
          prevProductsChooseItemShowIdDataCategoryNo,
        );
        setValue(
          'goodsCategoryNo',
          (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
            ? JSON.stringify(prevProductsChooseItemShowDataCategoryNo)
            : '',
        );
        return;
      } else if (valueChooseNo === 0) {
        const prevProductsChooseDataIdStylesNo =
          productsChooseDataIdStylesNo.filter((item) => {
            return item !== addTypeName;
          });
        const prevProductsChooseItemDataStylesNo =
          productsChooseItemDataStylesNo.filter((item) => {
            return item.addTypeName !== addTypeName;
          });
        const prevProductsChooseItemShowDataStylesNo =
          productsChooseItemShowDataStylesNo.filter((item) => {
            return item.addTypeName !== addTypeName;
          });
        const prevProductsChooseItemShowIdDataStylesNo =
          productsChooseItemShowIdDataStylesNo.filter((item) => {
            return item !== addTypeName;
          });
        setProductsChooseDataIdStylesNo(prevProductsChooseDataIdStylesNo);
        setProductsChooseItemDataStylesNo(prevProductsChooseItemDataStylesNo);
        setProductsChooseItemShowDataStylesNo(
          prevProductsChooseItemShowDataStylesNo,
        );
        setProductsChooseItemShowIdDataStylesNo(
          prevProductsChooseItemShowIdDataStylesNo,
        );
        setValue(
          'goodsStylesNo',
          (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
            ? JSON.stringify(prevProductsChooseItemShowDataStylesNo)
            : '',
        );
        return;
      } else if (valueChooseNo === 1) {
        const prevProductsChooseDataIdGoodsNo =
          productsChooseDataIdGoodsNo.filter((item) => {
            return item !== addTypeName;
          });
        const prevProductsChooseItemDataGoodsNo =
          productsChooseItemDataGoodsNo.filter((item) => {
            return item.addTypeName !== addTypeName;
          });
        const prevProductsChooseItemShowDataGoodsNo =
          productsChooseItemShowDataGoodsNo.filter((item) => {
            return item.addTypeName !== addTypeName;
          });
        const prevProductsChooseItemShowIdDataGoodsNo =
          productsChooseItemShowIdDataGoodsNo.filter((item) => {
            return item !== addTypeName;
          });
        setProductsChooseDataIdGoodsNo(prevProductsChooseDataIdGoodsNo);
        setProductsChooseItemDataGoodsNo(prevProductsChooseItemDataGoodsNo);
        setProductsChooseItemShowDataGoodsNo(
          prevProductsChooseItemShowDataGoodsNo,
        );
        setProductsChooseItemShowIdDataGoodsNo(
          prevProductsChooseItemShowIdDataGoodsNo,
        );
        setValue(
          'goodsGoodsNo',
          (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
            ? JSON.stringify(prevProductsChooseItemShowDataGoodsNo)
            : '',
        );
        return;
      }
    };

    //可用商品的选择打开关闭
    const onCloseDialog = (data) => {
      if (data) {
        setProductsChooseItemShowData(productsChooseItemData);
        setProductsChooseItemShowIdData(productsChooseDataId);
        setProductsChooseItemShowDataSeries(productsChooseItemDataSeries);
        setProductsChooseItemShowIdDataSeries(productsChooseDataIdSeries);
        setProductsChooseItemShowDataStyles(productsChooseItemDataStyles);
        setProductsChooseItemShowIdDataStyles(productsChooseDataIdStyles); //存入勾选的值
        setProductsChooseItemShowDataGoods(productsChooseItemDataGoods);
        setProductsChooseItemShowIdDataGoods(productsChooseDataIdGoods);
        setProductsChooseItemShowDataSeason(productsChooseItemDataSeason);
        setProductsChooseItemShowIdDataSeason(productsChooseDataIdSeason);
        setProductsChooseItemShowDataSubclass(productsChooseItemDataSubclass);
        setProductsChooseItemShowIdDataSubclass(productsChooseDataIdSubclass);
        setProductsChooseItemShowDataDesign(productsChooseItemDataDesign);
        setProductsChooseItemShowIdDataDesign(productsChooseDataIdDesign);
        setProductsChooseItemShowDataCategory(productsChooseItemDataCategory);
        setProductsChooseItemShowIdDataCategory(productsChooseDataIdCategory);
      } else {
        setProductsChooseItemData(productsChooseItemShowData);
        setProductsChooseDataId(productsChooseItemShowIdData);
        setProductsChooseItemDataSeries(productsChooseItemShowDataSeries);
        setProductsChooseDataIdSeries(productsChooseItemShowIdDataSeries);
        setProductsChooseItemDataStyles(productsChooseItemShowDataStyles);
        setProductsChooseDataIdStyles(productsChooseItemShowIdDataStyles);
        setProductsChooseItemDataGoods(productsChooseItemShowDataGoods);
        setProductsChooseDataIdGoods(productsChooseItemShowIdDataGoods);
        setProductsChooseItemDataSeason(productsChooseItemShowDataSeason);
        setProductsChooseDataIdSeason(productsChooseItemShowIdDataSeason);
        setProductsChooseItemDataSubclass(productsChooseItemShowDataSubclass);
        setProductsChooseDataIdSubclass(productsChooseItemShowIdDataSubclass);
        setProductsChooseItemDataDesign(productsChooseItemShowDataDesign);
        setProductsChooseDataIdDesign(productsChooseItemShowIdDataDesign);
        setProductsChooseItemDataCategory(productsChooseItemShowDataCategory);
        setProductsChooseDataIdCategory(productsChooseItemShowIdDataCategory);
      }
      setValue(
        'goodsProduct',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemData)
          : '',
      );
      setValue(
        'goodsSeries',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemDataSeries)
          : '',
      );
      setValue(
        'goodsStyles',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemDataStyles)
          : '',
      );
      setValue(
        'goodsGoods',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemDataGoods)
          : '',
      );
      setValue(
        'goodsSeason',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemDataSeason)
          : '',
      );
      setValue(
        'goodsSubclass',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemDataSubclass)
          : '',
      );
      setValue(
        'goodsDesign',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemDataDesign)
          : '',
      );
      setValue(
        'goodsCategory',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemDataCategory)
          : '',
      );
      setDialogStatus(false);
    };

    //不可用商品的打开关闭
    const onCloseDialogNo = (data) => {
      if (data) {
        setProductsChooseItemShowDataNo(productsChooseItemDataNo);
        setProductsChooseItemShowIdDataNo(productsChooseDataIdNo);
        setProductsChooseItemShowDataSeriesNo(productsChooseItemDataSeriesNo);
        setProductsChooseItemShowIdDataSeriesNo(productsChooseDataIdSeriesNo);
        setProductsChooseItemShowDataStylesNo(productsChooseItemDataStylesNo);
        setProductsChooseItemShowIdDataStylesNo(productsChooseDataIdStylesNo);
        setProductsChooseItemShowDataGoodsNo(productsChooseItemDataGoodsNo);
        setProductsChooseItemShowIdDataGoodsNo(productsChooseDataIdGoodsNo);
        setProductsChooseItemShowDataSeasonNo(productsChooseItemDataSeasonNo);
        setProductsChooseItemShowIdDataSeasonNo(productsChooseDataIdSeasonNo);
        setProductsChooseItemShowDataSubclassNo(
          productsChooseItemDataSubclassNo,
        );
        setProductsChooseItemShowIdDataSubclassNo(
          productsChooseDataIdSubclassNo,
        );
        setProductsChooseItemShowDataDesignNo(productsChooseItemDataDesignNo);
        setProductsChooseItemShowIdDataDesignNo(productsChooseDataIdDesignNo);
        setProductsChooseItemShowDataCategoryNo(
          productsChooseItemDataCategoryNo,
        );
        setProductsChooseItemShowIdDataCategoryNo(
          productsChooseDataIdCategoryNo,
        );
      } else {
        setProductsChooseItemDataNo(productsChooseItemShowDataNo);
        setProductsChooseDataIdNo(productsChooseItemShowIdDataNo);
        setProductsChooseItemDataSeriesNo(productsChooseItemShowDataSeriesNo);
        setProductsChooseDataIdSeriesNo(productsChooseItemShowIdDataSeriesNo);
        setProductsChooseItemDataStylesNo(productsChooseItemShowDataStylesNo);
        setProductsChooseDataIdStylesNo(productsChooseItemShowIdDataStylesNo);
        setProductsChooseItemDataGoodsNo(productsChooseItemShowDataGoodsNo);
        setProductsChooseDataIdGoodsNo(productsChooseItemShowIdDataGoodsNo);
        setProductsChooseItemDataSeasonNo(productsChooseItemShowDataSeasonNo);
        setProductsChooseDataIdSeasonNo(productsChooseItemShowIdDataSeasonNo);
        setProductsChooseItemDataSubclassNo(
          productsChooseItemShowDataSubclassNo,
        );
        setProductsChooseDataIdSubclassNo(
          productsChooseItemShowIdDataSubclassNo,
        );
        setProductsChooseItemDataDesignNo(productsChooseItemShowDataDesignNo);
        setProductsChooseDataIdDesignNo(productsChooseItemShowIdDataDesignNo);
        setProductsChooseItemDataCategoryNo(
          productsChooseItemShowDataCategoryNo,
        );
        setProductsChooseDataIdCategoryNo(
          productsChooseItemShowIdDataCategoryNo,
        );
      }
      setValue(
        'goodsProductNo',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemDataNo)
          : '',
      );
      setValue(
        'goodsSeriesNo',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemDataSeriesNo)
          : '',
      );
      setValue(
        'goodsStylesNo',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemDataStylesNo)
          : '',
      );
      setValue(
        'goodsGoodsNo',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemDataGoodsNo)
          : '',
      );
      setValue(
        'goodsSeasonNo',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemDataSeasonNo)
          : '',
      );
      setValue(
        'goodsSubclassNo',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemDataSubclassNo)
          : '',
      );
      setValue(
        'goodsDesignNo',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemDataDesignNo)
          : '',
      );
      setValue(
        'goodsCategoryNo',
        (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
          ? JSON.stringify(productsChooseItemDataCategoryNo)
          : '',
      );
      setDialogStatusNo(false);
    };

    const handleChange = (event, newValue) => {
      handleClickSearchProducts && handleClickSearchProducts('');
      handleClickSearchProductsStyles && handleClickSearchProductsStyles('');
      handleClickSearchProductsSeries && handleClickSearchProductsSeries('');
      handleClickSearchProductsGoods && handleClickSearchProductsGoods('');
      handleClickSearchProductsSeason && handleClickSearchProductsSeason('');
      handleClickSearchProductsSubclass &&
        handleClickSearchProductsSubclass('');
      handleClickSearchProductsDesign && handleClickSearchProductsDesign('');
      handleClickSearchProductsCategory &&
        handleClickSearchProductsCategory('');
      setTabValue(newValue);
    };
    const handleChangeChoose = (event, newValue) => {
      setTabValueChoose(newValue);
    };
    const handleChangeChooseNo = (event, newValue) => {
      setTabValueChooseNo(newValue);
    };
    //可用商品lab
    const labelCom = (
      <Box className="init-tabs-wrap-style">
        <Box display="flex" justifyContent="space-between">
          <Box>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'coupon.mgt.pricevalue.n01.txt81',
                })}
                {...a11yProps(0)}
              />
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'coupon.mgt.pricevalue.n01.txt82',
                })}
                {...a11yProps(1)}
              />
              <Tab className="init-tab-style" label="SKU" {...a11yProps(2)} />
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'coupon.mgt.pricevalue.n01.txt83',
                })}
                {...a11yProps(3)}
              />
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'coupon.mgt.pricevalue.n01.txt84',
                })}
                {...a11yProps(4)}
              />
              <Tab className="init-tab-style" label="款式" {...a11yProps(5)} />
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'coupon.mgt.pricevalue.n01.txt85',
                })}
                {...a11yProps(6)}
              />
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'coupon.mgt.pricevalue.n01.txt86',
                })}
                {...a11yProps(7)}
              />
            </Tabs>
          </Box>
          {onCloseDialog ? (
            <IconButton aria-label="close" onClick={() => onCloseDialog()}>
              <CloseIcon className="coupon-dialog-close-icon-style" />
            </IconButton>
          ) : null}
        </Box>
      </Box>
    );

    //不可用商品
    const labelComNo = (
      <Box className="init-tabs-wrap-style">
        <Box display="flex" justifyContent="space-between">
          <Box>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'coupon.mgt.pricevalue.n01.txt81',
                })}
                {...a11yProps(0)}
              />
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'coupon.mgt.pricevalue.n01.txt82',
                })}
                {...a11yProps(1)}
              />
              <Tab className="init-tab-style" label="SKU" {...a11yProps(2)} />
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'coupon.mgt.pricevalue.n01.txt83',
                })}
                {...a11yProps(3)}
              />
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'coupon.mgt.pricevalue.n01.txt84',
                })}
                {...a11yProps(4)}
              />
              <Tab className="init-tab-style" label="款式" {...a11yProps(5)} />
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'coupon.mgt.pricevalue.n01.txt85',
                })}
                {...a11yProps(6)}
              />
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'coupon.mgt.pricevalue.n01.txt86',
                })}
                {...a11yProps(7)}
              />
            </Tabs>
          </Box>
          {onCloseDialogNo ? (
            <IconButton aria-label="close" onClick={() => onCloseDialogNo()}>
              <CloseIcon className="coupon-dialog-close-icon-style" />
            </IconButton>
          ) : null}
        </Box>
      </Box>
    );

    //打开商品选中model
    const storesAddClick = (type) => {
      setTabValue(0);
      if (type === 1) {
        if (productsNameRef.current && productsNameRef.current.value) {
          productsNameRef.current.value = '';
        }
        if (
          productsNameSeriesRef.current &&
          productsNameSeriesRef.current.value
        ) {
          productsNameSeriesRef.current.value = '';
        }
        if (
          productsNameStylesRef.current &&
          productsNameStylesRef.current.value
        ) {
          productsNameStylesRef.current.value = '';
        }
        if (
          productsNameGoodsRef.current &&
          productsNameGoodsRef.current.value
        ) {
          productsNameGoodsRef.current.value = '';
        }
        if (
          productsNameSeasonRef.current &&
          productsNameSeasonRef.current.value
        ) {
          productsNameSeasonRef.current.value = '';
        }
        if (
          productsNameSubclassRef.current &&
          productsNameSubclassRef.current.value
        ) {
          productsNameSubclassRef.current.value = '';
        }
        if (
          productsNameDesignRef.current &&
          productsNameDesignRef.current.value
        ) {
          productsNameDesignRef.current.value = '';
        }
        if (
          productsNameCategoryRef.current &&
          productsNameCategoryRef.current.value
        ) {
          productsNameCategoryRef.current.value = '';
        }
      } else {
        if (productsNameRefNo.current && productsNameRefNo.current.value) {
          productsNameRefNo.current.value = '';
        }
        if (
          productsNameSeriesRefNo.current &&
          productsNameSeriesRefNo.current.value
        ) {
          productsNameSeriesRefNo.current.value = '';
        }
        if (
          productsNameStylesRefNo.current &&
          productsNameStylesRefNo.current.value
        ) {
          productsNameStylesRefNo.current.value = '';
        }
        if (
          productsNameGoodsRefNo.current &&
          productsNameGoodsRefNo.current.value
        ) {
          productsNameGoodsRefNo.current.value = '';
        }
        if (
          productsNameSeasonRefNo.current &&
          productsNameSeasonRefNo.current.value
        ) {
          productsNameSeasonRefNo.current.value = '';
        }
        if (
          productsNameSubclassRefNo.current &&
          productsNameSubclassRefNo.current.value
        ) {
          productsNameSubclassRefNo.current.value = '';
        }
        if (
          productsNameDesignRefNo.current &&
          productsNameDesignRefNo.current.value
        ) {
          productsNameDesignRefNo.current.value = '';
        }
        if (
          productsNameCategoryRefNo.current &&
          productsNameCategoryRefNo.current.value
        ) {
          productsNameCategoryRefNo.current.value = '';
        }
      }
      setProductType(type);
      dispatch({
        type: 'couponsSetting/setProductsPage',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSize,
          },
        },
      });
      dispatch({
        type: 'couponsSetting/setProductsPageSeries',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeSeries,
          },
        },
      });
      // 获取款号
      dispatch({
        type: 'couponsSetting/setProductsPageStyles',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeStyles,
          },
        },
      });
      // 获取货号
      dispatch({
        type: 'couponsSetting/setProductsPageGoods',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeGoods,
          },
        },
      });
      dispatch({
        type: 'couponsSetting/setProductsPageSeason',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeSeason,
          },
        },
      });
      dispatch({
        type: 'couponsSetting/setProductsPageSubclass',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeSubclass,
          },
        },
      });
      dispatch({
        type: 'couponsSetting/setProductsPageDesign',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeDesign,
          },
        },
      });
      dispatch({
        type: 'couponsSetting/setProductsPageCategory',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeCategory,
          },
        },
      });

      handleClickSearchProducts && handleClickSearchProducts('');
      handleClickSearchProductsStyles && handleClickSearchProductsStyles('');
      handleClickSearchProductsSeries && handleClickSearchProductsSeries('');
      handleClickSearchProductsGoods && handleClickSearchProductsGoods('');
      handleClickSearchProductsSeason && handleClickSearchProductsSeason('');
      handleClickSearchProductsSubclass &&
        handleClickSearchProductsSubclass('');
      handleClickSearchProductsDesign && handleClickSearchProductsDesign('');
      handleClickSearchProductsCategory &&
        handleClickSearchProductsCategory('');
      type === 1 ? setDialogStatus(true) : setDialogStatusNo(true);
    };
    const onHandleClickSearchProducts = () => {
      dispatch({
        type: 'couponsSetting/setProductsPage',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSize,
          },
        },
      });
      handleClickSearchProducts &&
        handleClickSearchProducts(productsNameRef.current?.value);
    };
    const onHandleClickSearchProductsSeries = () => {
      dispatch({
        type: 'couponsSetting/setProductsPageSeries',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeSeries,
          },
        },
      });
      handleClickSearchProductsSeries &&
        handleClickSearchProductsSeries(productsNameSeriesRef.current?.value);
    };
    // 款号商品
    const onHandleClickSearchProductsStyles = () => {
      dispatch({
        type: 'couponsSetting/setProductsPageStyles',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeStyles,
          },
        },
      });
      handleClickSearchProductsStyles &&
        handleClickSearchProductsStyles(productsNameStylesRef.current?.value);
    };
    // 货号商品
    const onHandleClickSearchProductsGoods = () => {
      dispatch({
        type: 'couponsSetting/setProductsPageGoods',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeGoods,
          },
        },
      });
      handleClickSearchProductsGoods &&
        handleClickSearchProductsGoods(productsNameGoodsRef.current?.value);
    };
    const onHandleClickSearchProductsSeason = () => {
      dispatch({
        type: 'couponsSetting/setProductsPageSeason',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeSeason,
          },
        },
      });
      handleClickSearchProductsSeason &&
        handleClickSearchProductsSeason(productsNameSeasonRef.current?.value);
    };
    const onHandleClickSearchProductsSubclass = () => {
      dispatch({
        type: 'couponsSetting/setProductsPageSubclass',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeSubclass,
          },
        },
      });
      handleClickSearchProductsSubclass &&
        handleClickSearchProductsSubclass(
          productsNameSubclassRef.current?.value,
        );
    };

    // 款式搜索
    const onHandleClickSearchProductsDesign = () => {
      dispatch({
        type: 'couponsSetting/setProductsPageDesign',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeDesign,
          },
        },
      });
      handleClickSearchProductsDesign &&
        handleClickSearchProductsDesign(productsNameDesignRef.current?.value);
    };
    const onHandleClickSearchProductsCategory = () => {
      dispatch({
        type: 'couponsSetting/setProductsPageCategory',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeCategory,
          },
        },
      });
      handleClickSearchProductsCategory &&
        handleClickSearchProductsCategory(
          productsNameCategoryRef.current?.value,
        );
    };
    const onHandleClickSearchProductsNo = () => {
      dispatch({
        type: 'couponsSetting/setProductsPage',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSize,
          },
        },
      });
      handleClickSearchProducts &&
        handleClickSearchProducts(productsNameRefNo.current?.value);
    };
    const onHandleClickSearchProductsSeriesNo = () => {
      dispatch({
        type: 'couponsSetting/setProductsPageSeries',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeSeries,
          },
        },
      });
      handleClickSearchProductsSeries &&
        handleClickSearchProductsSeries(productsNameSeriesRefNo.current?.value);
    };
    const onHandleClickSearchProductsStylesNo = () => {
      dispatch({
        type: 'couponsSetting/setProductsPageStyles',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeStyles,
          },
        },
      });
      handleClickSearchProductsStyles &&
        handleClickSearchProductsStyles(productsNameStylesRefNo.current?.value);
    };
    const onHandleClickSearchProductsGoodsNo = () => {
      dispatch({
        type: 'couponsSetting/setProductsPageGoods',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeGoods,
          },
        },
      });
      handleClickSearchProductsGoods &&
        handleClickSearchProductsGoods(productsNameGoodsRefNo.current?.value);
    };
    const onHandleClickSearchProductsSeasonNo = () => {
      dispatch({
        type: 'couponsSetting/setProductsPageSeason',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeSeason,
          },
        },
      });
      handleClickSearchProductsSeason &&
        handleClickSearchProductsSeason(productsNameSeasonRefNo.current?.value);
    };
    const onHandleClickSearchProductsSubclassNo = () => {
      dispatch({
        type: 'couponsSetting/setProductsPageSubclass',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeSubclass,
          },
        },
      });
      handleClickSearchProductsSubclass &&
        handleClickSearchProductsSubclass(
          productsNameSubclassRefNo.current?.value,
        );
    };
    // 不可用款式搜索
    const onHandleClickSearchProductsDesignNo = () => {
      dispatch({
        type: 'couponsSetting/setProductsPageDesign',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeDesign,
          },
        },
      });
      handleClickSearchProductsDesign &&
        handleClickSearchProductsDesign(productsNameDesignRefNo.current?.value);
    };
    const onHandleClickSearchProductsCategoryNo = () => {
      dispatch({
        type: 'couponsSetting/setProductsPageCategory',
        payload: {
          value: {
            pageNum: 1,
            pageSize: productsPageSizeCategory,
          },
        },
      });
      handleClickSearchProductsCategory &&
        handleClickSearchProductsCategory(
          productsNameCategoryRefNo.current?.value,
        );
    };
    console.log({ productsNameGoods });
    const productsContent = () => {
      return (
        <Box>
          {/* 款式产品 */}
          <TabPanel value={value} index={0} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      <Input
                        placeholder={formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt87',
                        })}
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsNameStyles}
                        ref={productsNameStylesRef}
                        onChange={(e) => {
                          productsNameStylesRef.current.value = e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProductsStyles}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columnsTabData}
                data={productsListStyles}
                columnKey="addTypeName"
                total={productsTotalStyles}
                devicesMinWidth="794"
                chooseIds={productsChooseDataIdStyles}
                page={{
                  pageSize: Math.abs(productsPageSizeStyles),
                  pageNum: Math.abs(productsPageNumStyles),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPageStyles',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
          {/* 货号产品 */}
          <TabPanel value={value} index={1} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      <Input
                        placeholder={formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt88',
                        })}
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsNameGoods}
                        ref={productsNameGoodsRef}
                        onChange={(e) => {
                          productsNameGoodsRef.current.value = e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProductsGoods}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columnsTabData}
                data={productsListGoods}
                columnKey="addTypeName"
                total={productsTotalGoods}
                devicesMinWidth="794"
                chooseIds={productsChooseDataIdGoods}
                page={{
                  pageSize: Math.abs(productsPageSizeGoods),
                  pageNum: Math.abs(productsPageNumGoods),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPageGoods',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={2} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      <Input
                        placeholder={formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt89',
                        })}
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsName}
                        ref={productsNameRef}
                        onChange={(e) => {
                          productsNameRef.current.value = e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProducts}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columns}
                data={productsList}
                columnKey="id"
                total={productsTotal}
                devicesMinWidth="794"
                chooseIds={productsChooseDataId}
                page={{
                  pageSize: Math.abs(productsPageSize),
                  pageNum: Math.abs(productsPageNum),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPage',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={3} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      <Input
                        placeholder={formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt90',
                        })}
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsNameSeries}
                        ref={productsNameSeriesRef}
                        onChange={(e) => {
                          productsNameSeriesRef.current.value = e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProductsSeries}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columnsTabData}
                data={productsListSeries}
                columnKey="addTypeName"
                total={productsTotalSeries}
                devicesMinWidth="794"
                chooseIds={productsChooseDataIdSeries}
                page={{
                  pageSize: Math.abs(productsPageSizeSeries),
                  pageNum: Math.abs(productsPageNumSeries),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPageSeries',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={4} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      <Input
                        placeholder={formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt91',
                        })}
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsNameSeason}
                        ref={productsNameSeasonRef}
                        onChange={(e) => {
                          productsNameSeasonRef.current.value = e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProductsSeason}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columnsTabData}
                data={productsListSeason}
                columnKey="id"
                total={productsTotalSeason}
                devicesMinWidth="794"
                chooseIds={productsChooseDataIdSeason}
                page={{
                  pageSize: Math.abs(productsPageSizeSeason),
                  pageNum: Math.abs(productsPageNumSeason),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPageSeason',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={5} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      <Input
                        placeholder="请输入款式"
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsNameDesign}
                        ref={productsNameDesignRef}
                        onChange={(e) => {
                          productsNameDesignRef.current.value = e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProductsDesign}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columnsTabData}
                data={productsListDesign}
                columnKey="id"
                total={productsTotalDesign}
                devicesMinWidth="794"
                chooseIds={productsChooseDataIdDesign}
                page={{
                  pageSize: Math.abs(productsPageSizeDesign),
                  pageNum: Math.abs(productsPageNumDesign),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPageDesign',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={6} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      <Input
                        placeholder={formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt92',
                        })}
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsNameSubclass}
                        ref={productsNameSubclassRef}
                        onChange={(e) => {
                          productsNameSubclassRef.current.value =
                            e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProductsSubclass}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columnsTabData}
                data={productsListSubclass}
                columnKey="id"
                total={productsTotalSubclass}
                devicesMinWidth="794"
                chooseIds={productsChooseDataIdSubclass}
                page={{
                  pageSize: Math.abs(productsPageSizeSubclass),
                  pageNum: Math.abs(productsPageNumSubclass),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPageSubclass',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={7} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      <Input
                        placeholder={formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt93',
                        })}
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsNameCategory}
                        ref={productsNameCategoryRef}
                        onChange={(e) => {
                          productsNameCategoryRef.current.value =
                            e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProductsCategory}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columnsTabData}
                data={productsListCategory}
                columnKey="id"
                total={productsTotalCategory}
                devicesMinWidth="794"
                chooseIds={productsChooseDataIdCategory}
                page={{
                  pageSize: Math.abs(productsPageSizeCategory),
                  pageNum: Math.abs(productsPageNumCategory),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPageCategory',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
        </Box>
      );
    };

    const productsContentNo = () => {
      return (
        <Box>
          <TabPanel value={value} index={0} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      <Input
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsNameStyles}
                        ref={productsNameStylesRefNo}
                        onChange={(e) => {
                          productsNameStylesRefNo.current.value =
                            e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        placeholder={formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt94',
                        })}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProductsStylesNo}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columnsTabData}
                data={productsListStyles}
                columnKey="addTypeName"
                total={productsTotalStyles}
                devicesMinWidth="794"
                chooseIds={productsChooseDataIdStylesNo}
                page={{
                  pageSize: Math.abs(productsPageSizeStyles),
                  pageNum: Math.abs(productsPageNumStyles),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPageStyles',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
          {/* 货号产品 */}
          <TabPanel value={value} index={1} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      {/* <InputLabel htmlFor="standard-adornment-password">
                      </InputLabel> */}
                      <Input
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsNameGoods}
                        ref={productsNameGoodsRefNo}
                        onChange={(e) => {
                          productsNameGoodsRefNo.current.value = e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        placeholder={formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt95',
                        })}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProductsGoodsNo}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columnsTabData}
                data={productsListGoods}
                columnKey="addTypeName"
                total={productsTotalGoods}
                devicesMinWidth="794"
                chooseIds={productsChooseDataIdGoodsNo}
                page={{
                  pageSize: Math.abs(productsPageSizeGoods),
                  pageNum: Math.abs(productsPageNumGoods),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPageGoods',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={2} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      <InputLabel htmlFor="standard-adornment-password">
                        {formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt89',
                        })}
                      </InputLabel>
                      <Input
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsName}
                        ref={productsNameRefNo}
                        onChange={(e) => {
                          productsNameRefNo.current.value = e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProductsNo}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columns}
                data={productsList}
                columnKey="id"
                total={productsTotal}
                devicesMinWidth="794"
                chooseIds={productsChooseDataIdNo}
                page={{
                  pageSize: Math.abs(productsPageSize),
                  pageNum: Math.abs(productsPageNum),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPage',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={3} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      <InputLabel htmlFor="standard-adornment-password">
                        {formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt90',
                        })}
                      </InputLabel>
                      <Input
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsNameSeries}
                        ref={productsNameSeriesRefNo}
                        onChange={(e) => {
                          productsNameSeriesRefNo.current.value =
                            e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProductsSeriesNo}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columnsTabData}
                data={productsListSeries}
                columnKey="addTypeName"
                total={productsTotalSeries}
                devicesMinWidth="794"
                chooseIds={productsChooseDataIdSeriesNo}
                page={{
                  pageSize: Math.abs(productsPageSizeSeries),
                  pageNum: Math.abs(productsPageNumSeries),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPageSeries',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={4} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      <InputLabel htmlFor="standard-adornment-password">
                        {formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt91',
                        })}
                      </InputLabel>
                      <Input
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsNameSeason}
                        ref={productsNameSeasonRefNo}
                        onChange={(e) => {
                          productsNameSeasonRefNo.current.value =
                            e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProductsSeasonNo}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columnsTabData}
                data={productsListSeason}
                columnKey="id"
                total={productsTotalSeason}
                devicesMinWidth="794"
                chooseIds={productsChooseDataIdSeasonNo}
                page={{
                  pageSize: Math.abs(productsPageSizeSeason),
                  pageNum: Math.abs(productsPageNumSeason),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPageSeason',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={5} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      <InputLabel htmlFor="standard-adornment-password">
                        款式
                      </InputLabel>
                      <Input
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsNameDesign}
                        ref={productsNameDesignRefNo}
                        onChange={(e) => {
                          productsNameDesignRefNo.current.value =
                            e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProductsDesignNo}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columnsTabData}
                data={productsListDesign}
                columnKey="id"
                total={productsTotalDesign}
                devicesMinWidth="794"
                chooseIds={productsChooseDataIdDesignNo}
                page={{
                  pageSize: Math.abs(productsPageSizeDesign),
                  pageNum: Math.abs(productsPageNumDesign),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPageDesign',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={6} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      <InputLabel htmlFor="standard-adornment-password">
                        {formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt92',
                        })}
                      </InputLabel>
                      <Input
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsNameSubclass}
                        ref={productsNameSubclassRefNo}
                        onChange={(e) => {
                          productsNameSubclassRefNo.current.value =
                            e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProductsSubclassNo}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columnsTabData}
                data={productsListSubclass}
                columnKey="id"
                total={productsTotalSubclass}
                devicesMinWidth="794"
                chooseIds={productsChooseDataIdSubclassNo}
                page={{
                  pageSize: Math.abs(productsPageSizeSubclass),
                  pageNum: Math.abs(productsPageNumSubclass),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPageSubclass',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={7} className="init-tabs-wrap">
            <Box display="flex" justifyContent="flex-end">
              <Box width="261px">
                <Controller
                  render={(pr) => (
                    <FormControl
                      sx={{ m: 1, width: '100%' }}
                      variant="standard"
                    >
                      <InputLabel htmlFor="standard-adornment-password">
                        {formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt93',
                        })}
                      </InputLabel>
                      <Input
                        id="standard-adornment-password"
                        type="text"
                        value={pr.value ?? productsNameCategory}
                        ref={productsNameCategoryRefNo}
                        onChange={(e) => {
                          productsNameCategoryRefNo.current.value =
                            e.target.value;
                          return pr.onChange(e.target.value);
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={onHandleClickSearchProductsCategoryNo}
                              // onMouseDown={handleMouseDownPassword}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  )}
                  control={control}
                  name=""
                />
              </Box>
            </Box>
            <Box className="table-dialog-width-style">
              <DataTableNativeML
                paging={true}
                columns={columnsTabData}
                data={productsListCategory}
                columnKey="id"
                total={productsTotalCategory}
                devicesMinWidth="794"
                chooseIds={productsChooseDataIdCategoryNo}
                page={{
                  pageSize: Math.abs(productsPageSizeCategory),
                  pageNum: Math.abs(productsPageNumCategory),
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={(data) => {
                  dispatch({
                    type: 'couponsSetting/setProductsPageCategory',
                    payload: {
                      value: {
                        pageNum: data.pageNum,
                        pageSize: data.pageSize,
                      },
                    },
                  });
                }}
              />
            </Box>
          </TabPanel>
        </Box>
      );
    };

    /*
     * importButtonStatus 1可用商品， 2不可用商品
     * here
     */
    const storesImportClick = (buttonStatus) => {
      setBatchImportOpen(true);
      setImportButtonStatus(buttonStatus);
    };
    //打开关闭批量导入dialog
    const onCloseBatchImportDialog = () => {
      setBatchImportOpen(false);
      setImportStatus('ready');
      setUploadSuccessData();
    };
    //批量导入的内容部分
    const batchImportContent = () => {
      return (
        <Loading loading={importFetchStatus}>
          <Box gap="16px 0" display="flex" flexDirection="column">
            <Box display="flex" alignItems="center">
              <Box
                sx={{
                  width: '32px',
                  height: '32px',
                  fontSize: '16px',
                  color: '#ffffff',
                  background: theme.palette.primary.main,
                  borderRadius: '50%',
                  textAlign: 'center',
                  lineHeight: '32px',
                  marginRight: '10px',
                }}
              >
                1
              </Box>
              <Box sx={{ fontSize: '16px', color: '#212121' }}>
                根据标准模板格式填写信息，前往
                <span
                  style={{
                    color: theme.palette.primary.main,
                    cursor: 'pointer',
                  }}
                  onClick={handleDownloadExcelTemplate}
                >
                  下载模板{'>'}
                  {'>'}
                </span>
              </Box>
            </Box>
            <Box display="flex" alignItems="center">
              <Box
                sx={{
                  width: '32px',
                  height: '32px',
                  fontSize: '16px',
                  color: '#ffffff',
                  background: theme.palette.primary.main,
                  borderRadius: '50%',
                  textAlign: 'center',
                  lineHeight: '32px',
                  marginRight: '10px',
                }}
              >
                2
              </Box>
              <Box sx={{ fontSize: '16px', color: '#212121' }}>
                点击上传文件按钮，上传后系统将对文件内容进行检查
              </Box>
            </Box>
            {importStatus !== 'ready' && (
              <Box
                sx={{
                  border:
                    importStatus === 'success'
                      ? '2px solid #4CAF50'
                      : importStatus === 'warning'
                      ? '2px solid #FF9800'
                      : '2px solid #FF3B30',
                  borderRadius: '5px',
                  padding: '12px 24px',
                  marginBottom: importStatus === 'fail' ? '16px' : 0,
                }}
              >
                <Box
                  sx={{
                    height: '22px',
                    lineHeight: '22px',
                    fontSize: '16px',
                    color:
                      importStatus === 'success'
                        ? '#4CAF50'
                        : importStatus === 'warning'
                        ? '#FF9800'
                        : '#FF3B30',
                  }}
                >
                  {importStatus === 'success' ? (
                    '文件上传成功'
                  ) : importStatus === 'warning' ? (
                    <>
                      文件内容校验异常，点我
                      <span
                        style={{
                          color: theme.palette.primary.main,
                          cursor: 'pointer',
                        }}
                        onClick={handleDownloadExcelFailData}
                      >
                        下载文件{'>'}
                        {'>'}
                      </span>
                    </>
                  ) : (
                    '文件上传失败'
                  )}
                </Box>
                <Box
                  sx={{
                    lineHeight: '22px',
                    fontSize: '16px',
                    color: '#212121',
                    marginTop: '8px',
                  }}
                >
                  {importStatus === 'success' ? (
                    `共计上传${uploadSuccessData?.totalNum}条数据，成功${uploadSuccessData?.successNum}条，失败${uploadSuccessData?.failNum}条。`
                  ) : importStatus === 'warning' ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `共计上传${uploadSuccessData?.totalNum}条数据，成功${uploadSuccessData?.successNum}条，失败${uploadSuccessData?.failNum}条。<br />你可以下载未上传成功的数据`,
                      }}
                    />
                  ) : (
                    '请下载模板，按照指定方式上传！'
                  )}
                </Box>
              </Box>
            )}
          </Box>
        </Loading>
      );
    };
    //批量导入底部按钮自定义
    const initButton = () => {
      const buttonNode = (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: '0 32px',
            width: '100%',
            marginBottom: '16px',
          }}
        >
          {importStatus === 'ready' && (
            <Button
              sx={{ width: '100px!important' }}
              variant="contained"
              onClick={handleUploadExcel}
            >
              上传文件
            </Button>
          )}
          {(importStatus === 'success' || importStatus === 'warning') && (
            <Button
              sx={{ width: '100px!important' }}
              variant="contained"
              onClick={!importFetchStatus && onContinueBatchImport}
            >
              继续
            </Button>
          )}
          {(importStatus === 'success' || importStatus === 'warning') && (
            <Button
              sx={{
                width: '100px!important',
                color: theme.palette.primary.main,
              }}
              variant="outlined"
              onClick={onCloseBatchImportDialog}
            >
              取消
            </Button>
          )}
        </Box>
      );
      return { buttonNode, isShow: importStatus !== 'fail' };
    };

    //下载模板
    const handleDownloadExcelTemplate = () => {
      download('/common/importGoodsTemplate');
    };

    //上传excel
    const handleUploadExcel = () => {
      inputUploadExcelRef.current.click();
    };

    //批量上传
    const handleFileChange = (e) => {
      setImportFetchStatus(1);
      let skuProductNo = [];
      let spuAddTypeName = [];
      let materialCodeAddTypeName = [];
      //importButtonStatus=1可用else 不可用
      if (importButtonStatus === 1) {
        skuProductNo = productsChooseItemShowData?.map(
          (item) => item.productNo,
        );
        spuAddTypeName = productsChooseItemShowDataStyles?.map(
          (item) => item.addTypeName,
        );
        materialCodeAddTypeName = productsChooseItemShowDataGoods?.map(
          (item) => item.addTypeName,
        );
      } else {
        skuProductNo = productsChooseItemShowDataNo?.map(
          (item) => item.productNo,
        );
        spuAddTypeName = productsChooseItemShowDataStylesNo?.map(
          (item) => item.addTypeName,
        );
        materialCodeAddTypeName = productsChooseItemShowDataGoodsNo?.map(
          (item) => item.addTypeName,
        );
      }
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      formData.append('materialCode', materialCodeAddTypeName); //货号
      formData.append('spu', spuAddTypeName); //款号
      formData.append('sku', skuProductNo);
      // 上传excel
      uploadExcel(file, formData, '/common/importGoods', (res) => {
        if (res?.code === 0) {
          if (res.data.failNum === 0) {
            setImportStatus('success');
          } else {
            setImportStatus('warning');
          }
          setUploadSuccessData(res.data);
        } else {
          setImportStatus('fail');
        }
        inputUploadExcelRef.current.value = '';
        setImportFetchStatus();
      });
    };
    //点击批量导入的继续按钮
    const onContinueBatchImport = () => {
      //spu款号、materialCode货号、sku
      const { sku, spu, materialCode } = uploadSuccessData;
      if (importButtonStatus === 1) {
        const filterSku = sku.filter(
          (item) => !productsChooseDataId.includes(item.id),
        );
        const filterSpu = spu.filter(
          (item) => !productsChooseDataIdStyles.includes(item.addTypeName),
        );
        const filterMaterial = materialCode.filter(
          (item) => !productsChooseDataIdGoods.includes(item.addTypeName),
        );
        const defaultIds = filterSku.map((item) => item.id);
        const defaultIdsStyles = filterSpu.map((item) => item.addTypeName);
        const defaultIdsGoods = filterMaterial.map((item) => item.addTypeName);
        //sku开始
        setProductsChooseDataId([...productsChooseDataId, ...defaultIds]);
        setProductsChooseItemShowIdData([
          ...productsChooseDataId,
          ...defaultIds,
        ]);
        setProductsChooseItemData([...productsChooseItemData, ...filterSku]);
        setProductsChooseItemShowData([
          ...productsChooseItemShowData,
          ...filterSku,
        ]);
        setValue(
          'goodsProduct',
          JSON.stringify([...productsChooseItemShowData, ...filterSku]),
        );
        //sku结束
        //spu开始
        setProductsChooseDataIdStyles([
          ...productsChooseDataIdStyles,
          ...defaultIdsStyles,
        ]);
        setProductsChooseItemShowIdDataStyles([
          ...productsChooseItemShowIdDataStyles,
          ...defaultIdsStyles,
        ]);
        setProductsChooseItemDataStyles([
          ...productsChooseItemDataStyles,
          ...filterSpu,
        ]);
        setProductsChooseItemShowDataStyles([
          ...productsChooseItemShowDataStyles,
          ...filterSpu,
        ]);
        setValue(
          'goodsStyles',
          JSON.stringify([...productsChooseItemShowDataStyles, ...filterSpu]),
        );
        //spu结束
        //货号开始
        setProductsChooseDataIdGoods([
          ...productsChooseDataIdGoods,
          ...defaultIdsGoods,
        ]);
        setProductsChooseItemShowIdDataGoods([
          ...productsChooseDataIdGoods,
          ...defaultIdsGoods,
        ]);
        setProductsChooseItemDataGoods([
          ...productsChooseItemDataGoods,
          ...filterMaterial,
        ]);
        setProductsChooseItemShowDataGoods([
          ...productsChooseItemShowDataGoods,
          ...filterMaterial,
        ]);
        setValue(
          'goodsGoods',
          JSON.stringify([
            ...productsChooseItemShowDataGoods,
            ...filterMaterial,
          ]),
        );
        //货号结束
      } else {
        const filterSku = sku.filter(
          (item) => !productsChooseDataIdNo.includes(item.id),
        );
        const filterSpu = spu.filter(
          (item) => !productsChooseDataIdStylesNo.includes(item.addTypeName),
        );
        const filterMaterial = materialCode.filter(
          (item) => !productsChooseDataIdGoodsNo.includes(item.addTypeName),
        );
        const defaultIds = filterSku.map((item) => item.id);
        const defaultIdsStyles = filterSpu.map((item) => item.addTypeName);
        const defaultIdsGoods = filterMaterial.map((item) => item.addTypeName);
        setProductsChooseDataIdNo([...productsChooseDataIdNo, ...defaultIds]);
        setProductsChooseItemShowIdDataNo([
          ...productsChooseItemShowIdDataNo,
          ...defaultIds,
        ]);
        setProductsChooseItemDataNo([
          ...productsChooseItemDataNo,
          ...filterSku,
        ]);
        setProductsChooseItemShowDataNo([
          ...productsChooseItemShowDataNo,
          ...filterSku,
        ]);
        setValue(
          'goodsProductNo',
          JSON.stringify([...productsChooseItemShowDataNo, ...filterSku]),
        );

        setProductsChooseDataIdStylesNo([
          ...productsChooseDataIdStylesNo,
          ...defaultIdsStyles,
        ]);
        setProductsChooseItemShowIdDataStylesNo([
          ...productsChooseItemShowIdDataStylesNo,
          ...defaultIdsStyles,
        ]);
        setProductsChooseItemDataStylesNo([
          ...productsChooseItemDataStylesNo,
          ...filterSpu,
        ]);
        setProductsChooseItemShowDataStylesNo([
          ...productsChooseItemShowDataStylesNo,
          ...filterSpu,
        ]);
        setValue(
          'goodsStylesNo',
          JSON.stringify([...productsChooseItemDataStylesNo, ...filterSpu]),
        );
        setProductsChooseDataIdGoodsNo([
          ...productsChooseDataIdGoodsNo,
          ...defaultIdsGoods,
        ]);
        setProductsChooseItemShowIdDataGoodsNo([
          ...productsChooseDataIdGoodsNo,
          ...defaultIdsGoods,
        ]);
        setProductsChooseItemDataGoodsNo([
          ...productsChooseItemDataGoodsNo,
          ...filterMaterial,
        ]);
        setProductsChooseItemShowDataGoodsNo([
          ...productsChooseItemShowDataGoodsNo,
          ...filterMaterial,
        ]);
        setValue(
          'goodsGoodsNo',
          JSON.stringify([
            ...productsChooseItemShowDataGoodsNo,
            ...filterMaterial,
          ]),
        );
      }
      setBatchImportOpen(false);
      setImportStatus('ready');
      setUploadSuccessData();
    };
    //点击下载批量导入失败的数据
    const handleDownloadExcelFailData = () => {
      const { failFilePath } = uploadSuccessData;
      downLoadPrivateFile(failFilePath);
    };
    return (
      <Box className="step-form-wrap">
        <input
          className="input"
          type="file"
          ref={inputUploadExcelRef}
          hidden
          onChange={(event) => handleFileChange(event)}
          accept={
            ('application/vnd.ms-excel.xlsx',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
          }
        />
        <form onSubmit={handleSubmit(onSubmitSuccess)}>
          <Box display="flex">
            {/*内容*/}
            <Box flex="1" pl={7}>
              <Box>
                <TitleML
                  title={formatMessage({
                    id: 'coupon.mgt.volume.n03.lbl01',
                  })}
                  fontSize="19px"
                />
                <Box>
                  {/*适用商品*/}
                  <Box width="100%" mt={7.5}>
                    <Box fontSize="14px" fontWeight="400" color="#000" mb={1.6}>
                      <span style={{ color: 'red' }}>*</span>{' '}
                      {formatMessage({
                        id: 'coupon.mgt.volume.n03.rdo02',
                      })}
                    </Box>
                    <Box display="flex">
                      <Controller
                        render={(pr) => (
                          <RadioGroup
                            className="checkbox-radio-disabled-color"
                            aria-label="couponUsingThreshold"
                            onChange={(e) => {
                              setProductsTypeChooseState(e.target.value);
                              deProductsTypeChooseState = undefined;
                              return pr.onChange(e.target.value);
                            }}
                            value={
                              productsTypeChooseState ??
                              deProductsTypeChooseState
                            }
                          >
                            <Box display="flex" gridGap="0 53px">
                              <Box display="flex" mr={11}>
                                <FormControlLabel
                                  variant="standard"
                                  value="1"
                                  control={<Radio />}
                                  label={
                                    <Box color="#000" lineHeight="1">
                                      {formatMessage({
                                        id: 'coupon.mgt.volume.n03.lbl03',
                                      })}
                                    </Box>
                                  }
                                  disabled={queryType === 'detail'}
                                />
                              </Box>
                              <Box mr={11}>
                                <FormControlLabel
                                  variant="standard"
                                  value="0"
                                  control={<Radio />}
                                  label={
                                    <Box color="#000" lineHeight="1">
                                      {formatMessage({
                                        id: 'coupon.mgt.volume.n03.lbl04',
                                      })}
                                    </Box>
                                  }
                                  disabled={queryType === 'detail'}
                                />
                              </Box>
                            </Box>
                          </RadioGroup>
                        )}
                        control={control}
                        name="isAllGoods"
                        rules={{
                          validate: () => {
                            if (
                              (getValues('isAllGoods') === '0' &&
                                productsChooseItemShowData.length === 0 &&
                                productsChooseItemShowDataSeries.length === 0 &&
                                productsChooseItemShowDataStyles.length === 0 &&
                                productsChooseItemShowDataGoods.length === 0 &&
                                productsChooseItemShowDataSeason.length === 0 &&
                                productsChooseItemShowDataSubclass.length ===
                                  0 &&
                                productsChooseItemShowDataDesign.length === 0 &&
                                productsChooseItemShowDataCategory.length ===
                                  0 &&
                                productsChooseItemShowDataNo.length === 0 &&
                                productsChooseItemShowDataSeriesNo.length ===
                                  0 &&
                                productsChooseItemShowDataStylesNo.length ===
                                  0 &&
                                productsChooseItemShowDataGoodsNo.length ===
                                  0 &&
                                productsChooseItemShowDataSeasonNo.length ===
                                  0 &&
                                productsChooseItemShowDataSubclassNo.length ===
                                  0 &&
                                productsChooseItemShowDataDesignNo.length ===
                                  0 &&
                                productsChooseItemShowDataCategoryNo.length ===
                                  0) ||
                              (getValues('isAllGoods') === '0' &&
                                !(useProduct ?? deUseProduct) &&
                                !(noUseProduct ?? deNoUseProduct))
                            ) {
                              return false;
                            }
                            return true;
                          },
                        }}
                      />
                    </Box>
                    <Box className="init-error-style">
                      {errors.isAllGoods &&
                        formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt97',
                        })}
                    </Box>
                    {/*可用商品S*/}
                    {(productsTypeChooseState ?? deProductsTypeChooseState) ===
                      '0' && (
                      <Box>
                        {/*可用商品添加按钮*/}
                        <Box mt={2.375} display="flex">
                          <Box className="checkbox-radio-disabled-color">
                            <Controller
                              render={(pr) => (
                                <FormControlLabel
                                  variant="standard"
                                  checked={useProduct ?? deUseProduct}
                                  control={<Checkbox color="primary" />}
                                  label={
                                    <Box color="#000">
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt98',
                                      })}
                                    </Box>
                                  }
                                  onChange={(e) => {
                                    setUseProduct(e.target.checked);
                                    return pr.onChange(e.target.checked);
                                  }}
                                  disabled={queryType === 'detail'}
                                />
                              )}
                              control={control}
                              name="useProduct"
                            />
                          </Box>
                          {queryType !== 'detail' && (
                            <Button
                              disabled={
                                (productsTypeChooseState ??
                                  deProductsTypeChooseState) === '1'
                              }
                              variant="contained"
                              className="stores-setting-button"
                              onClick={() => storesAddClick(1)}
                            >
                              {formatMessage({
                                id: 'coupon.mgt.pricevalue.n01.txt75',
                              })}
                            </Button>
                          )}
                          {queryType !== 'detail' && (
                            <Button
                              disabled={
                                (productsTypeChooseState ??
                                  deProductsTypeChooseState) === '1'
                              }
                              variant="contained"
                              className="stores-setting-button"
                              onClick={() => storesImportClick(1)}
                              sx={{ marginLeft: '24px' }}
                            >
                              批量导入
                            </Button>
                          )}
                        </Box>
                        <Box mt={3.5}>
                          <Box width="726px" display="flex">
                            <Box className="init-tabs-wrap-style">
                              <Tabs
                                value={valueChoose}
                                onChange={handleChangeChoose}
                                aria-label="basic tabs example"
                              >
                                <Tab
                                  className="init-tab-style init-tab-style-one"
                                  label={formatMessage({
                                    id: 'coupon.mgt.pricevalue.n01.txt81',
                                  })}
                                  {...a11yProps(0)}
                                />
                                <Tab
                                  className="init-tab-style"
                                  label={formatMessage({
                                    id: 'coupon.mgt.pricevalue.n01.txt82',
                                  })}
                                  {...a11yProps(1)}
                                />
                                <Tab
                                  className="init-tab-style"
                                  label="SKU"
                                  {...a11yProps(2)}
                                />
                                <Tab
                                  className="init-tab-style"
                                  label={formatMessage({
                                    id: 'coupon.mgt.pricevalue.n01.txt83',
                                  })}
                                  {...a11yProps(3)}
                                />
                                <Tab
                                  className="init-tab-style"
                                  label={formatMessage({
                                    id: 'coupon.mgt.pricevalue.n01.txt84',
                                  })}
                                  {...a11yProps(4)}
                                />
                                <Tab
                                  className="init-tab-style"
                                  label="款式"
                                  {...a11yProps(5)}
                                />
                                <Tab
                                  className="init-tab-style"
                                  label={formatMessage({
                                    id: 'coupon.mgt.pricevalue.n01.txt85',
                                  })}
                                  {...a11yProps(6)}
                                />
                                <Tab
                                  className="init-tab-style init-tab-style-four"
                                  label={formatMessage({
                                    id: 'coupon.mgt.pricevalue.n01.txt86',
                                  })}
                                  {...a11yProps(7)}
                                />
                              </Tabs>
                            </Box>
                            <Box
                              flex="1"
                              borderBottom="1px solid #818286"
                            ></Box>
                          </Box>
                          <Box>
                            <TabPanel
                              value={valueChoose}
                              index={2}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumns}
                                  data={initDataTables(
                                    productsChooseItemShowData,
                                    productPage,
                                  )}
                                  columnKey="id"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowData.length > 0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleProductPrevious}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          productPage === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {productPage}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleProductDown}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          productPage * 10 >=
                                          productsChooseItemShowData.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowData.length || 0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                            <TabPanel
                              value={valueChoose}
                              index={3}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumnsTabData}
                                  data={initDataTables(
                                    productsChooseItemShowDataSeries,
                                    seriesPage,
                                  )}
                                  columnKey="addTypeName"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowDataSeries.length >
                                  0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleSeriesPrevious}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          seriesPage === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {seriesPage}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleSeriesDown}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          seriesPage * 10 >=
                                          productsChooseItemShowDataSeries.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowDataSeries.length ||
                                          0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                            <TabPanel
                              value={valueChoose}
                              index={4}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumnsTabData}
                                  // data={productsChooseItemShowDataSeason}
                                  data={initDataTables(
                                    productsChooseItemShowDataSeason,
                                    seasonPage,
                                  )}
                                  columnKey="id"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowDataSeason?.length >
                                  0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleSeasonPrevious}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          seasonPage === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {seasonPage}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleSeasonDown}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          seasonPage * 10 >=
                                          productsChooseItemShowDataSeason?.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowDataSeason?.length ||
                                          0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                            <TabPanel
                              value={valueChoose}
                              index={5}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumnsTabData}
                                  // data={productsChooseItemShowDataSubclass}
                                  data={initDataTables(
                                    productsChooseItemShowDataDesign,
                                    designPage,
                                  )}
                                  columnKey="id"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowDataDesign?.length >
                                  0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleDesignPrevious}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          designPage === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {designPage}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleDesignDown}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          designPage * 10 >=
                                          productsChooseItemShowDataDesign?.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowDataDesign?.length ||
                                          0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                            <TabPanel
                              value={valueChoose}
                              index={6}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumnsTabData}
                                  // data={productsChooseItemShowDataSubclass}
                                  data={initDataTables(
                                    productsChooseItemShowDataSubclass,
                                    subclassPage,
                                  )}
                                  columnKey="id"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowDataSubclass?.length >
                                  0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleSubclassPrevious}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          subclassPage === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {subclassPage}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleSubclassDown}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          subclassPage * 10 >=
                                          productsChooseItemShowDataSubclass?.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowDataSubclass?.length ||
                                          0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                            <TabPanel
                              value={valueChoose}
                              index={7}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumnsTabData}
                                  // data={productsChooseItemShowDataCategory}
                                  data={initDataTables(
                                    productsChooseItemShowDataCategory,
                                    categoryPage,
                                  )}
                                  columnKey="id"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowDataCategory?.length >
                                  0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleCategoryPrevious}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          categoryPage === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {categoryPage}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleCategoryDown}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          categoryPage * 10 >=
                                          productsChooseItemShowDataCategory?.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowDataCategory?.length ||
                                          0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                            <TabPanel
                              value={valueChoose}
                              index={0}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumnsTabData}
                                  // data={productsChooseItemShowDataStyles}
                                  data={initDataTables(
                                    productsChooseItemShowDataStyles,
                                    stylesPage,
                                  )}
                                  columnKey="addTypeName"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowDataStyles.length >
                                  0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleStylesPrevious}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          stylesPage === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {stylesPage}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleStylesDown}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          stylesPage * 10 >=
                                          productsChooseItemShowDataStyles.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowDataStyles.length ||
                                          0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                            <TabPanel
                              value={valueChoose}
                              index={1}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumnsTabData}
                                  // data={productsChooseItemShowDataGoods}
                                  data={initDataTables(
                                    productsChooseItemShowDataGoods,
                                    goodsPage,
                                  )}
                                  columnKey="addTypeName"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowDataGoods.length > 0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleGoodsPrevious}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          goodsPage === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {goodsPage}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleGoodsDown}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          goodsPage * 10 >=
                                          productsChooseItemShowDataGoods.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowDataGoods.length ||
                                          0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                          </Box>
                        </Box>
                      </Box>
                    )}
                    {/*可用商品E*/}

                    {/*不可用商品S*/}
                    {(productsTypeChooseState ?? deProductsTypeChooseState) ===
                      '0' && (
                      <Box>
                        {/*不可用商品添加按钮*/}
                        <Box mt={3.5} display="flex">
                          <Box className="checkbox-radio-disabled-color">
                            <Controller
                              render={(pr) => (
                                <FormControlLabel
                                  variant="standard"
                                  checked={noUseProduct ?? deNoUseProduct}
                                  control={<Checkbox color="primary" />}
                                  label={
                                    <Box color="#000">
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt100',
                                      })}
                                    </Box>
                                  }
                                  onChange={(e) => {
                                    setNoUseProduct(e.target.checked);
                                    return pr.onChange(e.target.checked);
                                  }}
                                  disabled={queryType === 'detail'}
                                />
                              )}
                              control={control}
                              name="noUseProduct"
                            />
                          </Box>
                          {queryType !== 'detail' && (
                            <Button
                              disabled={
                                (productsTypeChooseState ??
                                  deProductsTypeChooseState) === '1'
                              }
                              variant="contained"
                              className="stores-setting-button"
                              onClick={() => storesAddClick(2)}
                            >
                              {formatMessage({
                                id: 'coupon.mgt.pricevalue.n01.txt75',
                              })}
                            </Button>
                          )}
                          {queryType !== 'detail' && (
                            <Button
                              disabled={
                                (productsTypeChooseState ??
                                  deProductsTypeChooseState) === '1'
                              }
                              variant="contained"
                              className="stores-setting-button"
                              onClick={() => storesImportClick(2)}
                              sx={{ marginLeft: '24px' }}
                            >
                              批量导入
                            </Button>
                          )}
                        </Box>
                        <Box mt={3.5}>
                          <Box width="726px" display="flex">
                            <Box className="init-tabs-wrap-style">
                              <Tabs
                                value={valueChooseNo}
                                onChange={handleChangeChooseNo}
                                aria-label="basic tabs example"
                              >
                                <Tab
                                  className="init-tab-style init-tab-style-one"
                                  label={formatMessage({
                                    id: 'coupon.mgt.pricevalue.n01.txt81',
                                  })}
                                  {...a11yProps(0)}
                                />
                                <Tab
                                  className="init-tab-style"
                                  label={formatMessage({
                                    id: 'coupon.mgt.pricevalue.n01.txt82',
                                  })}
                                  {...a11yProps(1)}
                                />
                                <Tab
                                  className="init-tab-style"
                                  label="SKU"
                                  {...a11yProps(2)}
                                />
                                <Tab
                                  className="init-tab-style"
                                  label={formatMessage({
                                    id: 'coupon.mgt.pricevalue.n01.txt83',
                                  })}
                                  {...a11yProps(3)}
                                />
                                <Tab
                                  className="init-tab-style"
                                  label={formatMessage({
                                    id: 'coupon.mgt.pricevalue.n01.txt84',
                                  })}
                                  {...a11yProps(4)}
                                />
                                <Tab
                                  className="init-tab-style"
                                  label="款式"
                                  {...a11yProps(5)}
                                />
                                <Tab
                                  className="init-tab-style"
                                  label={formatMessage({
                                    id: 'coupon.mgt.pricevalue.n01.txt85',
                                  })}
                                  {...a11yProps(6)}
                                />
                                <Tab
                                  className="init-tab-style init-tab-style-four"
                                  label={formatMessage({
                                    id: 'coupon.mgt.pricevalue.n01.txt86',
                                  })}
                                  {...a11yProps(7)}
                                />
                              </Tabs>
                            </Box>
                            <Box
                              flex="1"
                              borderBottom="1px solid #818286"
                            ></Box>
                          </Box>
                          <Box>
                            <TabPanel
                              value={valueChooseNo}
                              index={2}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumnsNo}
                                  data={initDataTables(
                                    productsChooseItemShowDataNo,
                                    productPageNo,
                                  )}
                                  columnKey="id"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowDataNo.length > 0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleProductPreviousNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          productPageNo === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {productPageNo}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleProductDownNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          productPageNo * 10 >=
                                          productsChooseItemShowDataNo.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowDataNo.length ||
                                          0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                            <TabPanel
                              value={valueChooseNo}
                              index={3}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumnsTabDataNo}
                                  data={initDataTables(
                                    productsChooseItemShowDataSeriesNo,
                                    seriesPageNo,
                                  )}
                                  columnKey="addTypeName"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowDataSeriesNo.length >
                                  0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleSeriesPreviousNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          seriesPageNo === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {seriesPageNo}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleSeriesDownNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          seriesPageNo * 10 >=
                                          productsChooseItemShowDataSeriesNo.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowDataSeriesNo.length ||
                                          0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                            <TabPanel
                              value={valueChooseNo}
                              index={4}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumnsTabDataNo}
                                  // data={productsChooseItemShowDataSeasonNo}
                                  data={initDataTables(
                                    productsChooseItemShowDataSeasonNo,
                                    seasonPageNo,
                                  )}
                                  columnKey="id"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowDataSeasonNo?.length >
                                  0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleSeasonPreviousNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          seasonPageNo === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {seasonPageNo}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleSeasonDownNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          seasonPageNo * 10 >=
                                          productsChooseItemShowDataSeasonNo?.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowDataSeasonNo?.length ||
                                          0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                            <TabPanel
                              value={valueChooseNo}
                              index={5}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumnsTabDataNo}
                                  // data={productsChooseItemShowDataSubclassNo}
                                  data={initDataTables(
                                    productsChooseItemShowDataDesignNo,
                                    designPageNo,
                                  )}
                                  columnKey="id"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowDataDesignNo?.length >
                                  0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleDesignPreviousNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          designPageNo === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {designPageNo}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleDesignDownNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          designPageNo * 10 >=
                                          productsChooseItemShowDataDesignNo?.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowDataDesignNo?.length ||
                                          0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                            <TabPanel
                              value={valueChooseNo}
                              index={6}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumnsTabDataNo}
                                  // data={productsChooseItemShowDataSubclassNo}
                                  data={initDataTables(
                                    productsChooseItemShowDataSubclassNo,
                                    subclassPageNo,
                                  )}
                                  columnKey="id"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowDataSubclassNo?.length >
                                  0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleSubclassPreviousNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          subclassPageNo === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {subclassPageNo}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleSubclassDownNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          subclassPageNo * 10 >=
                                          productsChooseItemShowDataSubclassNo?.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowDataSubclassNo?.length ||
                                          0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                            <TabPanel
                              value={valueChooseNo}
                              index={7}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumnsTabDataNo}
                                  // data={productsChooseItemShowDataCategoryNo}
                                  data={initDataTables(
                                    productsChooseItemShowDataCategoryNo,
                                    categoryPageNo,
                                  )}
                                  columnKey="id"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowDataCategoryNo?.length >
                                  0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleCategoryPreviousNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          categoryPageNo === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {categoryPageNo}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleCategoryDownNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          categoryPageNo * 10 >=
                                          productsChooseItemShowDataCategoryNo?.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowDataCategoryNo?.length ||
                                          0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                            <TabPanel
                              value={valueChooseNo}
                              index={0}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumnsTabDataNo}
                                  // data={productsChooseItemShowDataStylesNo}
                                  data={initDataTables(
                                    productsChooseItemShowDataStylesNo,
                                    stylesPageNo,
                                  )}
                                  columnKey="addTypeName"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowDataStylesNo.length >
                                  0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleStylesPreviousNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          stylesPageNo === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {stylesPageNo}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleStylesDownNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          stylesPageNo * 10 >=
                                          productsChooseItemShowDataStylesNo.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowDataStylesNo.length ||
                                          0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                            <TabPanel
                              value={valueChooseNo}
                              index={1}
                              className="init-tabs-wrap"
                            >
                              <Box
                                width="728px"
                                p={1}
                                border="1px solid #818286"
                                borderTop="none"
                                borderRadius="3px"
                                borderTopLeftRadius="0"
                              >
                                <DataTableNativeML
                                  pageButton={false}
                                  columns={showColumnsTabDataNo}
                                  data={initDataTables(
                                    productsChooseItemShowDataGoodsNo,
                                    goodsPageNo,
                                  )}
                                  columnKey="addTypeName"
                                  total={100}
                                  devicesMinWidth="710"
                                  np={true}
                                />
                                {productsChooseItemShowDataGoodsNo.length >
                                  0 && (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap="0 12px"
                                    mt={1}
                                  >
                                    <Box
                                      onClick={handleGoodsPreviousNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          goodsPageNo === 1
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.03',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt99',
                                      })}
                                      {goodsPageNo}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                    <Box
                                      onClick={handleGoodsDownNo}
                                      sx={{
                                        cursor: 'pointer',
                                        color:
                                          goodsPageNo * 10 >=
                                          productsChooseItemShowDataGoodsNo.length
                                            ? '#C9C9C9'
                                            : 'inherit',
                                      }}
                                    >
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.04',
                                      })}
                                    </Box>
                                    <Box>
                                      {formatMessage({
                                        id: 'coupon.mgt.pricevalue.n01.txt76',
                                      })}
                                      {initPageSize(
                                        productsChooseItemShowDataGoodsNo.length ||
                                          0,
                                      )}
                                      {formatMessage({
                                        id: 'comm.pagination.lbl.05',
                                      })}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </TabPanel>
                          </Box>
                        </Box>
                      </Box>
                    )}
                    {/*不可用商品E*/}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          <Button
            type="submit"
            ref={submitRefThree}
            style={{ display: 'none' }}
          />
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsProduct"
            />
          </Box>
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsSeries"
            />
          </Box>
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsStyles"
            />
          </Box>
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsGoods"
            />
          </Box>
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsSeason"
            />
          </Box>
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsSubclass"
            />
          </Box>
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsDesign"
            />
          </Box>
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsCategory"
            />
          </Box>
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsProductNo"
            />
          </Box>
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsSeriesNo"
            />
          </Box>
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsStylesNo"
            />
          </Box>
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsGoodsNo"
            />
          </Box>
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsSeasonNo"
            />
          </Box>
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsSubclassNo"
            />
          </Box>
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsDesignNo"
            />
          </Box>
          <Box display="none">
            <Controller
              render={() => (
                <TextField
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                />
              )}
              control={control}
              name="goodsCategoryNo"
            />
          </Box>
        </form>
        <DialogML
          open={dialogStatus}
          title={labelCom}
          minheightinit={480}
          minwidthinit={800}
          describe={productsContent()}
          handleClose={onCloseDialog}
          specilaAlgorithmLabValue={'ok'}
          pageSource="coupon"
        />
        <DialogML
          open={dialogStatusNo}
          title={labelComNo}
          minheightinit={480}
          minwidthinit={800}
          describe={productsContentNo()}
          handleClose={onCloseDialogNo}
          specilaAlgorithmLabValue={'ok'}
          pageSource="coupon"
        />
        <DialogDataML
          open={batchImportOpen}
          title={
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <span style={{ fontSize: '18px', fontWeight: 600 }}>
                批量上传
              </span>
              <IconButton
                aria-label="close"
                onClick={() => onCloseBatchImportDialog()}
              >
                <CloseIcon className="coupon-dialog-close-icon-style" />
              </IconButton>
            </Box>
          }
          content={batchImportContent()}
          onClose={onCloseBatchImportDialog}
          button={initButton()}
        />
      </Box>
    );
  },
);
